import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Engagements, EngagementStatus, ServiceLineWithSolutionCode } from 'src/app/model/Engagement/Engagements';
import { KeyValue } from 'src/app/model/KeyValue';
import { Clients } from 'src/app/model/clients';
import { EngagementService } from 'src/app/services/EngagementService';
import { ClientService } from 'src/app/services/clientservice';
import { DataService } from 'src/app/services/data.service';
import { LoadingScreenService } from 'src/app/services/loading-screen.service';
import { of, Observable, forkJoin, switchMap, catchError, tap } from 'rxjs';
import { ClientMemberPermission, ClientMemberPermissionModel, TeamMemberPermission } from 'src/app/model/Engagement/TeamMemberPermission';
import { TeamMember, ValidationTeamMember } from 'src/app/model/Engagement/TeamMember';
import { RoleNames } from 'src/app/model/Role';
import { AppConfigService } from 'src/app/services/appConfigService';
import { Alert } from 'src/app/model/Alert';
import { AlertsService } from 'src/app/services/alerts.service';
import { AppCodes, Applicationmaster } from 'src/app/model/ApplicationMaster';
import { ApplicationMasterService } from 'src/app/services/application-master.service';
import { MembersList } from 'src/app/model/MembersList';
import { AzureADUsersArrayList, SearchGroupUserViewModel } from 'src/app/model/AzureADUsersArrayList';
import { AdUsersService } from 'src/app/services/adusers.service';
import { ChangeOrderService } from 'src/app/services/change-order.service';
import { ChangeOrderAssignmentModel, ChangeOrderModel, EditChangeOrderModel } from 'src/app/model/change-order/change-order-model';
import { AddWorkspaceDocumentValidationModel, MappingTemplatePackageModel } from 'src/app/model/TemplatePackageModel';
import { TemplateMaintenanceService } from 'src/app/services/template-maintenance.service';
import { TemplateMappingModel } from 'src/app/model/TemplateMappingModel';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { DocumentService } from 'src/app/services/DocumentService';
import { WorkspaceService } from 'src/app/services/workspace.service';
import { NewWorkspaceData, WorkspaceModel } from 'src/app/model/WorkspaceModel';
import { HDWorkItemDocumentModel, HDWorkItemModel } from 'src/app/model/HDWorkItemModel';
import { HotDocsService } from 'src/app/services/HotDocsService';
import { EngagementAssignmentWithoutSCode, NewEngAssignmentWrapperModel, PrimaryWorkspaceModel } from 'src/app/model/Engagement/CreateEngagementData';
import { WorkspaceDocumentModel } from 'src/app/model/WorkspaceDocumentModel';
import { CloseoutChecklistWorkspaceModel } from 'src/app/model/Workspace/CloseoutChecklistWorkspaceModel';
import { EnumTeamMemberRoleCodes, EnumKeyTeamMemberRoleCodes, TeamMemberRole } from 'src/app/model/Engagement/TeamMemberRole';
import { EngagementAssignment } from 'src/app/model/Engagement/EngagementAssignments';
import { CLMService } from 'src/app/services/clm.service';
import { ADUser, UpdatePermissionsModel, UpdatePermissionsModelData, UsersListEmailModel } from 'src/app/model/SharePoiint/ActiveDirectory';
import { ActiveDirectoryService } from 'src/app/services/activedirectory.service';
import { CollaborationSite, CollaborationSiteMembers, CollaborationSiteViewModel, CurrentCollaborationSiteViewModel } from 'src/app/model/CollaborationSite';
import { ChangeOrderTemplateEnum } from 'src/app/model/change-order/change-order.enums'
import { ChangeOrderValidationModel } from 'src/app/model/change-order/change-order-validation-model';
import { ChangeOrderAssignment } from 'src/app/model/change-order/change-order-assignment';
import { Title } from '@angular/platform-browser';
import { EngagementStatusViewModel } from 'src/app/model/Engagement/engagement-status-view-model';
import { OneViewClientOpportunityViewModel, OneViewClientOpportunityViewModelWrapper, OpportunityServiceMiniModel, OpportunityServiceModel, SearchClientOpportunityForContinuanceByRequestModel, SearchClientOpportunityForSecondaryAssignmentByRequestModel, SearchOpportunityByEngagementIdRequestModel } from 'src/app/model/Client/CreateClientViewModel';
import { EngagementCollaborationsViewModel, EngagementList, EngagementListModel } from 'src/app/model/EngagementListModel';
import { SecondarySolutionCode } from 'src/app/model/Engagement/SecondarySolutionCodes';
import { ClientLocation } from 'src/app/model/Client/ClientLocation';
import { ClientBillingContact } from 'src/app/model/Client/ClientBillingContact';
import { BooleanKeyValue } from 'src/app/model/BooleanKeyValue';
import { FieldValidator } from 'src/app/model/Engagement/FieldValidator';
import { ContactTypes } from 'src/app/model/Client/ContactTypes';
import { InterchangeableSolutionCode } from 'src/app/model/Engagement/InterchangeableSolutioncodes';
import { ContinuanceDialogTitles } from 'src/app/model/InitiateNewEngagement';
import { EngagementDialogTitles } from 'src/app/model/Engagement/Engagements';
import { Subscription } from 'rxjs';
import { NewClient } from 'src/app/model/Client/NewClient';
import { Employee } from 'src/app/model/Workspace/Employee';
import { AssignmentRequest } from 'src/app/model/Workspace/AssignmentRequest';
import { CreateAssignmentRequestModel } from 'src/app/model/Workspace/CreateAssignmentRequestModel';
import { AssignmentResponseList, AssignmentResponse } from 'src/app/model/Workspace/AssignmentResponse';
import { SearchEmployeeModel } from 'src/app/model/Workspace/SearchEmployeeModel';
import { EngagementESignature } from 'src/app/model/Engagement/EngagementESignature';
import { CMSService } from 'src/app/services/cmsservice.service';
import { GraphService } from 'src/app/services/Integration/graphservice.service';
import { AssignmentChangeOrderOpportunitySelection } from 'src/app/common/popups/change-order-assignment-opportunity-popup/change-order-assignment-opportunity-popup.component';
import { FetchXMLTemplateService } from 'src/app/services/fetchXmlTemplate.service';
import { FetchXMLTemplateRequest } from 'src/app/model/Engagement/FetchXMLTemplateModel';
import { FetchXMLTemplateNamesSource } from 'src/app/model/Common/FetchXMLTemplateNamesSource';
import { MemberFirmData } from 'src/app/model/MemberFirm/member-firm-data';
import { DatePipe } from '@angular/common';

declare var $;
@Component({
  selector: 'app-initiate-change-order',
  templateUrl: './initiate-change-order.component.html',
  styleUrls: ['./initiate-change-order.component.css']
})
export class InitiateChangeOrderComponent implements OnInit, OnDestroy {
  changeOrderId: number
  engagementId: number = -1;
  engagementName: string;
  startDateCtrlId: string;
  teamMemberlblCtrlName: string;
  INDUSRoleName: string;
  clientId: number = -1;
  selectedAssignmentCodeId:number=0;
  currentCollabModel: CurrentCollaborationSiteViewModel;
  azureADUsersArrayListMemberFirm: AzureADUsersArrayList;
  azureADUsersArrayListAdmin: AzureADUsersArrayList;
  financialUpdate: boolean = false;
  public assignmentItem: EngagementAssignment = new EngagementAssignment();
  isOpportunityServiceFeatureFlagEnabled: boolean = false;
  isPrepopulateFromDetails: boolean = false;
  clientkeyValueList: KeyValue[] = [];
  engagementkeyValueList: KeyValue[] = [];
  clients: Clients[];
  assignAdminList: AzureADUsersArrayList;
   isloggedInUserAdmin: string = 'no';
   memberFirmData: MemberFirmData;
  engagementCollaborationsViewModel: EngagementCollaborationsViewModel = new EngagementCollaborationsViewModel();
  isINDUSStaffingManagerLoggedIn: boolean;
  isQualityUserLoggedIn: boolean;
  newCollabrationCount: number = 0;
  isDisableAddCollaborationSite: boolean = true;
searchClientOpportunityByRequestModel: SearchClientOpportunityForSecondaryAssignmentByRequestModel = new SearchClientOpportunityForSecondaryAssignmentByRequestModel();
  engagementList: EngagementList = new EngagementList();
  isLoggedInUserSystemAdmin: boolean;
  engagement: Engagements;
  engagements: Engagements[];
  changeOrderHistoryList: ChangeOrderModel[];
  defaultPermissionId: number;
  teamMemberPermissions: TeamMemberPermission[] = [];
  uiTeamMemberList: Array<TeamMember> = [];
  arrValidationForNewTeamMember: ValidationTeamMember[] = [];
  isDisableForADV029: boolean = false;
  isDisableSolutionCode: boolean = false;
  isAllValidatedPassedOfAddassignment:boolean = false;
  IsValidInput: boolean = false;
  cmsDataMatch = false;
  newCollabTeamMember: any = {};
  changeOrderTeamMemberList: Array<TeamMember> = [];
  newAssignTeamMember: any = {};
  teamMemberLimit: number;
  teamMemberRoleName: string;
  alert: Alert;
  newTeamMember: any = {};
  validateTM: boolean[] = new Array(15);
  isUserAgentIE: number;
  teamMemberRoleCodes: AppCodes[] = [];
  eppmdRoleIdAppMaster: number;
  applicationmasterList: Applicationmaster[] = [];
  applicationmasterListIE: Applicationmaster[] = [];
  teamMemberRoleFromAppMstList: Applicationmaster[] = [];
  keyteamMemberRoleFromAppMstList: Applicationmaster[] = [];
  governingAgreementOptionAppMstList: Applicationmaster[] = [];
  keyTeamMemberRoleCodes: AppCodes[] = [];
  isAudit: boolean = false;
  isMemberFirm: boolean = false;
  userObject: any;
  isvalidSignatureHandler: boolean = true;

  teamMemberCtrl: string; // people picker variables
  teamMemberEmailCtrl: string;
  membersListArrayForTeamMembers: MembersList[];
  selectedTMIndex: string;
  currentTeamMemberIndex: number;
  objectArray: [string, any][];
  teamMemberRoleList: TeamMemberRole[] = [];
  clientOpportunityList: OneViewClientOpportunityViewModel[] = [];
  engagementTeamMembersList: CollaborationSiteMembers[] = [];
  public arrEngagementAssignment: Array<EngagementAssignment> = [];
  isRemoveAssignmentConfirmed:boolean = false;
  existingGACheck: boolean;
  defaultClientBillingContact: ClientBillingContact;
  adminDisplayUserName = '';
  adminDisplayUserEmail = '';
  isAssignmentNameExistForClient: boolean = false;
  isvalidcmsEPPMDName: boolean = true;

  assignAdminRoleName: string;
  currentAssignmentRowIndex: number = 0;
  validateCMSAA: boolean;
  validateCMSEP: boolean;
    selectedEPIndex: string;

  selectedCMSEPIndex: string;
  selectedCMSAAIndex: string;
  membersListArray: MembersList[];
  membersListArrayForEP: MembersList[];
  isVisibledefaultAssignmentDiv = false;
  secondarySolutionCodeList: SecondarySolutionCode[] = [];
  primarySelectedSolutionCode: SecondarySolutionCode = new SecondarySolutionCode();

  selectedSolutionCode: string;
  engtypekeyValueList: KeyValue[] = [];
  peoplepickerIndex: number = 0;
  validateEQCR: boolean;
    epRoleName: string;

  CMSEPCtrl: string;
  ASAdminCtrl: string;
  selectedEQCRIndex: string;
  EQCRNameCtrl: string;
  EQCRCtrl: string;
  EQCRRoleName: string;
  EQCRlblCtrlName: string;
  cmsCodeRequestError: boolean;
    clmLsDownloadFileFromSharepoitisRunning = false;
  accountId: string = "";
  arrSecondarySolutionCode: SecondarySolutionCode[] = [];
  isInvalidClientBillingContactEmail: boolean = false;
arrControlValidation: FieldValidator[] = [];
  ClientLocations: ClientLocation[] = [];
  contingentkeyValueList: BooleanKeyValue[] = [];
  isNewAssignmentNameDuplicate = false;
  cmslblCtrlName: string;
  eplblCtrlName:string;
    signatureHandlerRoleName: string;

  cmsDisplayUserName = '';
  cmsDisplayUserEmail = '';
    assignAdminlblCtrlName: string;
signatureHandlers: MembersList[];
  handerlblCtrlName: string;
  ClientContactTypes: ContactTypes[] = [];
  validEGrossMargin: boolean = true;
  grossMarginMessage: string = '';
  AssignmentCodeRequested: string = "Request sent";
  defaultEngAssignment: EngagementAssignment = new EngagementAssignment();
  editDefaultEngAssignment: EngagementAssignment = new EngagementAssignment();
  TemplateList: MappingTemplatePackageModel[] = [];
  isTemplateMappingFound: boolean;
  SelectedTemp: TemplateMappingModel = new TemplateMappingModel();
  documentCategory: string = 'Create New Engagement';
  SelectedTemplateList: MappingTemplatePackageModel[] = [];
  invalidvalues: string;
  source: string;
  public engagementAssignmentWithoutSCode: Array<EngagementAssignmentWithoutSCode> = [];
  isclientSelected: boolean = true;
  isEngagementSelected: boolean = true;
  isChangeorderTemplateSelected: boolean = true;
  selectedChangeOrderTemplate: string;
  isEstimationDateFilled: boolean = true;
  EstimationDate: string;
  isIncrementalFeesFilled: boolean = true;
  IncrementalFees: number;
  validRealization: boolean = true;
  RealizationMessage: string = '';
  validNetfees: boolean = true;
  netFeesMessage: string = '';
  dateCompareResult: number;
  DateCompareResult: number;
  isvalidAassignmentAdministrator: boolean = true;

  yearValidationResult: number;
  isvalidEED: boolean = true;
  validAssignmentName = true;
StartDateCtrlId: string;
  EndDateCtrlId: string;
  isvalidESD: boolean = true;
  isGrossMarginFilled: boolean = true;
  Grossmargin: number;
  PlaceholderText: string = "Enter...";
  changeOrderModel: ChangeOrderModel = new ChangeOrderModel();
  workspaceId: string;
  strdefaultcontingentkeyValues: any = {};
  addWorkspace_SelectedData: AddWorkspaceDocumentValidationModel = new AddWorkspaceDocumentValidationModel();
  addWorkspace_SiteUniqueId: string;
  createChangeorderValidation: boolean = false;
  addWorkspace_PrimaryWorkspaceStatus: string;
  createWorkItemDetails: HDWorkItemModel = new HDWorkItemModel();
  workItemDetails: HDWorkItemModel = new HDWorkItemModel();
  workspaceData: PrimaryWorkspaceModel = new PrimaryWorkspaceModel();
  addWorkspaceDocumentList: WorkspaceDocumentModel[] = [];
  invalidvaluesAN: string;
  invalidvaluesCN: string;
  isEditAssignmentClicked:boolean = false
  addWorkspace_InsertWorspaceDeatils: CloseoutChecklistWorkspaceModel = new CloseoutChecklistWorkspaceModel();
  updateWorkSpaceData: NewWorkspaceData = new NewWorkspaceData();
  CurrentWorkspaceData: WorkspaceModel = new WorkspaceModel();
  updateWorkspacModel: WorkspaceModel = new WorkspaceModel();
  // ChangeOrderAssigment variables
  changeOrderAssignments: ChangeOrderAssignment[] = [];
  currentChangeOrderAssignments: ChangeOrderAssignment[] = [];
  primaryChangeOrderAssignments: ChangeOrderAssignment[] = [];
  changeOrderAssignmentModel: ChangeOrderAssignment = new ChangeOrderAssignment();
  changeOrderAssignmentModelValue: ChangeOrderAssignmentModel = new ChangeOrderAssignmentModel();
  changeOrderAssignmentValues: ChangeOrderAssignmentModel[] = [];
  netFeesPlaceholder: string = "$0";
  marginPlaceholder: string = "00%";
  startDateCompareResult: number;
  isAssignmentSelected: boolean = false;
  editMode: boolean = false;
  editChangeOrderModel: EditChangeOrderModel = new EditChangeOrderModel();
  createdDate: string;
  newEngAssignment: any = {};
  engAssignmentData: any[] = [];
  collaborationSiteMembersList: CollaborationSiteMembers[] = [];
  collaborationSiteList: CollaborationSite[] = [];

  changeOrderWorkspaceId: string;
  bindEditData: boolean = false;
  bindEditTemplateData: boolean = false;
  engagementStatusViewModel: EngagementStatusViewModel;
  //Changeorder opportunity popup variables - Starts
  isModalOpen: boolean = false;
  primarySolutionCode: string = "";
  isPageLoad = false;
  modalDialogRef: Subscription;
  dialogTitle = '';
  dialogButtonName = '';
  assignmentToRemove: any = null;
  isChangeOrderScreen: boolean = false;
opportunityList: OneViewClientOpportunityViewModel[] = [];
oneViewClientOpportunityViewModelWrapper: OneViewClientOpportunityViewModelWrapper = new OneViewClientOpportunityViewModelWrapper();

  opportunityIdVal: string = '';
  errorMessage: string;
  annuityOpportunity: boolean = false;
  interchangeableSolutionCodes: InterchangeableSolutionCode[] = [];


  public engagementAssignmentList: Array<ChangeOrderAssignment> = [];
  secondarySolutionCode: SecondarySolutionCode[] = [];
  isDisabled: boolean = false;
  employeeList: Employee[] = [];
  unsavedAlertfeature_AnyFormFieldChanged: boolean = false;
  unsavedAlertfeature_IsSaveChangesOrNextBtnClicked: boolean = false;
  clientMemberPermissions: ClientMemberPermission[] = [];
  clientMemberPermissionModelList: ClientMemberPermissionModel[] = [];
  defaultClientPermissionId: number;
  selectedChangeOrderClient: Engagements = new Engagements();
  unsavedAlertfeature_DefaultAssignmentValues: EngagementAssignment = null;

  //Changeorder opportunity popup variables - Ends
  constructor(private dataService: DataService,
    private _fetchXMLTemplateService: FetchXMLTemplateService,
    private loadingService: LoadingScreenService,
    private titleService: Title,
    private loadingScreenService: LoadingScreenService,
    private router: Router,
    private data: DataService,
    private _alertService: AlertsService,
    private _activedirectoryService: ActiveDirectoryService,
    private clientService: ClientService,
    private engagementService: EngagementService,
    private activatedRoute: ActivatedRoute,
    private appService: AppConfigService,
    private alertService: AlertsService,
    private graphSerivce: GraphService,
    private applicationMasterService: ApplicationMasterService,
    private renderer: Renderer2,
    private el: ElementRef,
    private datePipe: DatePipe,
    private cmsService: CMSService,
    private adUsersService: AdUsersService,
    private changeOrderService: ChangeOrderService,
    private templateMaintenanceService: TemplateMaintenanceService,
    private configService: ConfigurationService,
    private documentService: DocumentService,
    private workspaceService: WorkspaceService,
    private hdService: HotDocsService,
    private clmService: CLMService,
    private activedirectoryService: ActiveDirectoryService,
    private _configService: ConfigurationService,  ) {
    const jsonString = localStorage.getItem('currentUser');
    this.userObject = JSON.parse(jsonString);
    this.teamMemberLimit = this.appService.config.DATA.TEAM_MEMEBR_LIMIT;
    this.teamMemberRoleName = RoleNames.GTUSINDUSALL.toString();
    const IEversion = localStorage.getItem('isUserAgentIE');
    this.isUserAgentIE = JSON.parse(IEversion);
  }



  selectedPermission: number[] = [];
  ngOnInit() {
    this.editMode = false;
    this.source = 'EngagementType';
    this.userObject = JSON.parse(localStorage.getItem('currentUser'));
     this.isMemberFirm = this.userObject.isMemberFirmFeatureEnabled;
    this.PerformDialogAction();
    this.InitializeMasterDataForAssignmentSecion(this.source);
    this.GetContactTypes();
    this.GetClientLocations();
    const currentPath = this.activatedRoute.snapshot.url.join('/');
    if (currentPath === "NewChangeOrder") {
      this.editMode = false;
      this.selectedChangeOrderTemplate = "-1";

    } else {
      this.editMode = true;
      if (currentPath != null && currentPath.includes('/')) {
        let currentUrlValues = currentPath.split('/');
        let ChangeOrderid = currentUrlValues[1];
        if (ChangeOrderid != null && ChangeOrderid != undefined && ChangeOrderid != "") {
          this.changeOrderService.getChangeOrderById(Number(ChangeOrderid)).subscribe({
            next: result => {
              this.editChangeOrderModel = result;
              this.bindEditData = true;
              this.bindEditTemplateData = true;
              this.clientId = this.editChangeOrderModel.clientId;
              this.engagementId = this.editChangeOrderModel.engagementId;
              this.getSecondarySolutionCodeById(this.editChangeOrderModel.parentSolutionCodeId);
               var changeOrdersAssignmentValues = this.editChangeOrderModel.changeOrderAssignments;
                if (changeOrdersAssignmentValues != null && changeOrdersAssignmentValues.length > 0) {
                  this.isVisibledefaultAssignmentDiv = false;
                  changeOrdersAssignmentValues.forEach((element: any) => {
                    var assignment = new ChangeOrderAssignment();

                    assignment.assignmentCodeId = element.assignmentCodeId;
                    assignment.solutionCodeId = element.solutionCodeId;
                    assignment.solutionCode = element.solutionCode;
                    assignment.solutionCodeDescription = element.solutionCodeDescription;
                    assignment.assignmentName = element.assignmentName;
                    assignment.assignmentAdministrator = element.assignmentAdministrator;
                    assignment.realization = element.realization;
                    assignment.netFees = element.netFees;
                    assignment.adminEmailId = element.adminEmailId;
                    assignment.adminContactNo = element.adminContactNo;
                    assignment.engagementStartDate = element.engagementStartDate;
                    assignment.engagementEndDate = element.engagementEndDate;
                    assignment.assignmentCode = element.assignmentCode;
                    assignment.estimatedCompletetionDate = element.estimateCompletionDate;
                    assignment.cmsEPPMDName = element.cmsEPPMDName;
                    assignment.cmsEPPMDEmailId = element.cmsEPPMDEmailId;
                    assignment.engagementTypeId = element.engagementTypeId;
                    assignment.isPrimaryAssignment = element.isPrimaryAssignment;
                    assignment.officeLocationCodeId = element.officeLocationCodeId;
                    assignment.clientBillingContactName = element.clientBillingContactName;
                    assignment.clientBillingContactTitleId = element.clientBillingContactTitleId;
                    assignment.clientBillingContactEmail = element.clientBillingContactEmail;
                    assignment.eqcrName = element.eqcrName;
                    assignment.eqcrEmailId = element.eqcrEmailId;
                    assignment.opportunityServiceId = element.opportunityServiceId;
                    assignment.opportunityId = element.opportunityId;
                    assignment.opportunityName = element.opportunityName;
                    assignment.dayShapeLink = element.dayShapeLink;
                    assignment.estimatedGrossMargin = element.estimatedGrossMargin;
                    assignment.incrementalFees = element.incrementalFees ? '$' + Number(element.incrementalFees).toLocaleString('en-US') : '$0';
                    assignment.estimatedStartDate = element.estimateCompletionDate;
                    assignment.StartDateCtrlId = "EstimatedStartDate" + element.assignmentCodeId;
                    assignment.createdDate = element.createdDate?.toString();
                    assignment.createdBy = element.createdBy;
                    if (assignment.estimatedCompletetionDate != null &&
                      assignment.estimatedCompletetionDate != '0001-01-01T00:00:00') {
                      assignment.visible = true;
                      assignment.checked = true;
                    } else {
                      assignment.estimatedCompletetionDate = "";
                      assignment.grossMargin = "";
                      assignment.incrementalFees = "";
                      assignment.estimatedStartDate = "";
                    }
                    assignment.isChangeOrderAssignment = element.isChangeOrderAssignment;
                    this.currentChangeOrderAssignments.push(assignment);
                  });

                }

              this.redirectToCorrectEngagementState(this.editChangeOrderModel.workspaceId,this.editChangeOrderModel.status);
              this.changeOrderWorkspaceId = this.editChangeOrderModel.workspaceId;
              // Wait for getEngagementCollaborationsById to complete before executing dependent calls
                this.getEngagementCollaborationsById(this.engagementId).add(() => {
                this.getAssignmentsByEngId(this.engagementId, false);
                this.BindEngagementData(this.clientId);
                this.engagementName = this.editChangeOrderModel.engagementName;
                this.selectedChangeOrderTemplate = this.editChangeOrderModel.templatePackageId;
                this.getChangeOrderHistory();
                this.engagement = new Engagements();
                this.engagement.parentSolutionCodeId = this.editChangeOrderModel.parentSolutionCodeId;
                this.getEngagementDetailsById(this.engagementId);
                this.getEngagementTeamMembers(this.engagementId);
                this.btnUpdateTeamBtnClick(true);
                this.getWorkspaceDetailsById();



                if (this.editChangeOrderModel?.teamMembers != null && this.editChangeOrderModel?.teamMembers.length > 0) {
                  var indexValue = 0;
                  this.editChangeOrderModel?.teamMembers.forEach(element => {
                    if (!element.isReviewer) {
                      var teamMember = new ValidationTeamMember();
                      teamMember.memberEmailId = element.memberEmailId;
                      teamMember.memberName = element.memberName;
                      teamMember.teamMemberRole = element.teamMemberRole.toString();
                      teamMember.memeberContactNo = element.memeberContactNo;
                      teamMember.approvalStatus = element.approvalStatus;
                      teamMember.teamMemberPermissionId = element.teamMemberPermissionId;
                      teamMember.ishdnValidInputName = true;
                      teamMember.isUserExist = false;
                      teamMember.isNewUserDuplicate = false;
                      teamMember.index = indexValue;
                      this.selectedPermission.push(element.teamMemberPermissionId);
                      this.arrValidationForNewTeamMember.push(teamMember);
                      this.uiTeamMemberList.push(element);
                    }
                  });
                }

                // setTimeout(() => {
                //   if(this.currentChangeOrderAssignments.length > 0){
                //     // this.onChangeOrderAssinmentChange(this.currentChangeOrderAssignments[0]);
                //     this.prefillAssignmentDetails();
                //   }
                // }, 200);
              });
              // this.changeOrderTeamMemberList.push(ValidNewTeamMember);
              // );



              //  this.changeOrderAssignments = this.editChangeOrderModel.ChangeOrderAssignments;

            }, error: err => {
              console.error("failed to load change order history", err)
            }
          })
        }
      }
    }

    this.isDisableSolutionCode = false;
    this.StartDateCtrlId = "EstimatedStartDate";
    this.EndDateCtrlId = "EstimatedEndDate";
    this.teamMemberlblCtrlName = 'team member';
    this.teamMemberlblCtrlName = 'team member';
    this.epRoleName = RoleNames.EngagementPartner.toString();
    this.assignAdminRoleName = RoleNames.AssignmentAdministrator.toString();
    this.signatureHandlerRoleName = RoleNames.StaffMember.toString();
    this.eplblCtrlName = 'engagement PPMD';
    this.cmslblCtrlName = 'CMS PPMD';
    this.handerlblCtrlName = 'signature handler';
    this.assignAdminlblCtrlName = 'assignment administrator';
    this.teamMemberRoleName = RoleNames.StaffMember.toString();
    this.INDUSRoleName = RoleNames.INDUSConsent.toString();
    this.source = 'EngagementType';
    this.EQCRRoleName = RoleNames.AssignmentEQCR.toString();
    this.EQCRlblCtrlName = 'Assignment EQCR';

    this.activatedRoute.paramMap.subscribe(params => {
      this.changeOrderId = +params.get('changeOrderId');
      if (this.changeOrderId > 0) {
        this.editMode = true;
      }
    });
    this.engagementService.GetOpportunityServiceFeatureFlag().subscribe(result => {
      this.isOpportunityServiceFeatureFlagEnabled = result;
    });
    this.checkLoggedinUserSystemAdminRole();
    this.getTeamMemberRoles();
    this.getTeamMemberRoleList(); // from appmaster getting all field values to compare on UI and team member addition
    this.getKeyTeamMemberRoleList(); // from appmaster getting all field values to compare on UI and Key team member addition
    this.getTeamMemberPermissions(); // from appmaster getting all field values to compare on UI and team member addition
    this.getGoverningAgreementOption(); // from appmaster getting all field values to compare on UI and CLM template fetch
    this.clientService.getMyChangeOrderClients(this.userObject.loggedInUserEmail, this.isLoggedInUserSystemAdmin).subscribe({
      next: (result) => {
        this.clients = result;
        this.clientkeyValueList = this.getKeyValuePair(this.clients, 'clientId', 'clientName');
        if (this.editMode) {
          if (this.clientkeyValueList.length > 0 && this.clientkeyValueList.filter(cl => cl.key == this.editChangeOrderModel?.clientId?.toString()).length > 0) {
            this.clientId = this.editChangeOrderModel.clientId
            this.isclientSelected = true;
          }
          else
            this.clientId = -1;
        }
        this.checkPrefillClientAndEngagement();

      }, error: (err) => {

      }
    })
  }

  prefillAssignmentDetails(){
    this.engAssignmentData = [];
    this.editDefaultEngAssignment = null;
    this.defaultEngAssignment.assignmentCode = null;
      this.newEngAssignment = {
        engagementId: this.engagementList.engagementId,
        assignmentCodeId: this.currentChangeOrderAssignments[0].assignmentCodeId,
        solutionCodeId: this.currentChangeOrderAssignments[0].solutionCodeId,
        assignmentName: this.currentChangeOrderAssignments[0].assignmentName,
        assignmentAdministrator: this.currentChangeOrderAssignments[0].assignmentAdministrator,
        realization: this.currentChangeOrderAssignments[0].realization,
        netFees: this.currentChangeOrderAssignments[0].netFees,
        createdBy: this.currentChangeOrderAssignments[0].createdBy,
        createdDate: this.currentChangeOrderAssignments[0].createdDate,
        engagementEndDate: this.currentChangeOrderAssignments[0].engagementEndDate,
        engagementStartDate: this.currentChangeOrderAssignments[0].engagementStartDate,
        adminEmailId: this.currentChangeOrderAssignments[0].adminEmailId,
        adminContactNo: this.currentChangeOrderAssignments[0].adminContactNo,
        assignmentCode: this.currentChangeOrderAssignments[0].assignmentCode,
        cmsEPPMDName: this.currentChangeOrderAssignments[0].cmsEPPMDName,
        cmsEPPMDEmailId: this.currentChangeOrderAssignments[0].cmsEPPMDEmailId,
        engagementTypeId: this.currentChangeOrderAssignments[0].engagementTypeId,
        isContingent: this.currentChangeOrderAssignments[0].isContingent,
        isPrimaryAssignment: this.currentChangeOrderAssignments[0].isPrimaryAssignment,
        collaborationSiteId: '',
        officeLocationCodeId: this.currentChangeOrderAssignments[0].officeLocationCodeId,
        estimatedGrossMargin: this.currentChangeOrderAssignments[0].estimatedGrossMargin,
        clientBillingContactName: this.currentChangeOrderAssignments[0].clientBillingContactName,
        clientBillingContactTitleId: this.currentChangeOrderAssignments[0].clientBillingContactTitleId,
        clientBillingContactEmail: this.currentChangeOrderAssignments[0].clientBillingContactEmail,
        eqcrName: this.currentChangeOrderAssignments[0].eqcrName,
        eqcrEmailId: this.currentChangeOrderAssignments[0].eqcrEmailId,
        opportunityServiceId: this.currentChangeOrderAssignments[0].opportunityServiceId,
        opportunityId: this.currentChangeOrderAssignments[0].opportunityId,
        opportunityName: this.currentChangeOrderAssignments[0].opportunityName,
        dayShapeLink: this.currentChangeOrderAssignments[0].dayShapeLink,
        isChangeOrderAssignment: this.currentChangeOrderAssignments[0].isChangeOrderAssignment,
      };

      this.engAssignmentData.push(this.newEngAssignment);
      this.editDefaultEngAssignment = this.newEngAssignment;
      this.setAssignmentSection();
  }

   editAssignment(item: any) {
      this.isEditAssignmentClicked = true;
      this.isRemoveAssignmentConfirmed = false;
      this.isvalidESD = true;
      this.isvalidEED = true;
      this.isPageLoad = false;
      this.openDefaultAssignmentBox();
      this.defaultEngAssignment = JSON.parse(JSON.stringify(this.arrEngagementAssignment[0]));
      let selectedsolutionCode = this.secondarySolutionCodeList.find(s => s.childSolutionCodeId == this.defaultEngAssignment.solutionCodeId);
      this.defaultEngAssignment.selectedsolutionCode = selectedsolutionCode;
      if (this.defaultEngAssignment.opportunityServiceId != null && !this.defaultEngAssignment.isPrimaryAssignment) {
      }

      if (this.defaultEngAssignment.isPrimaryAssignment) {
        if (!(this.defaultEngAssignment.assignmentName.length > 0)) {//primary assignment name  is blank then prefill
          //this.prefilENName()
        }
        let val = $('#txtPeoplePicker_AS_EP_0').val();
        if (this.userObject.CMSEP != undefined && !(val?.length > 0)) {
          this.arrEngagementAssignment[0].cmsEPPMDName = this.userObject.CMSEP.displayName
          this.arrEngagementAssignment[0].cmsEPPMDEmailId = this.userObject.CMSEP.mail
          setTimeout(() => {
            $('#txtPeoplePicker_AS_EP_0').val(this.userObject.CMSEP.displayName);
            $('#UserHiddenProps_AS_EP_0 #hdnUserName').val(this.userObject.CMSEP.displayName);
            $('#UserHiddenProps_AS_EP_0 #hdnUserEmail').val(this.userObject.CMSEP.mail);
            $('#UserHiddenProps_AS_EP_0 #hdnUserPhone').val(this.userObject.CMSEP.businessPhones);
            $('#UserHiddenProps_AS_EP_0 #hdnJobTitle').val(this.userObject.CMSEP.jobTitle);
            $('#hdnValidInput_AS_EP_0').val(true);
            this.validateCMSEP = true;
          }, 10);
        }
      }

      this.editAssignmentDefaultValuesCheck(this.defaultEngAssignment);
      // this.InitializeMasterDataForAssignmentSecion(this.source);
      // this.GetContactTypes();
      // this.GetClientLocations();
       setTimeout(() => {
        this.getEngagementCollaborationsById(this.engagementId);
       }, 500);
      this.DateCompareResult = null;
      this.startDateCompareResult = null;
      this.isvalidcmsEPPMDName = true;
      this.isvalidAassignmentAdministrator = true;
      this.adminDisplayUserName = this.defaultEngAssignment.assignmentAdministrator;
      this.adminDisplayUserEmail = this.defaultEngAssignment.adminEmailId;
      this.userObject.AA = JSON.parse(JSON.stringify({ displayName: this.defaultEngAssignment.assignmentAdministrator, mail: this.defaultEngAssignment.adminEmailId, businessPhones: this.defaultEngAssignment.adminContactNo }));
      this.cmsDisplayUserEmail = this.defaultEngAssignment.cmsEPPMDEmailId;
      this.cmsDisplayUserName = this.defaultEngAssignment.cmsEPPMDName;
      this.validateCMSEP = true;
      this.validateCMSAA = true;
       this.setValidEQCRValue();

       if (this.secondarySolutionCodeList != undefined && this.secondarySolutionCodeList.length > 0) {
        this.defaultEngAssignment.solutionCodeListData = this.secondarySolutionCodeList;
        this.defaultEngAssignment.solutionCodeId =  this.secondarySolutionCodeList.find(s => s.childSolutionCodeId == this.defaultEngAssignment.solutionCodeId)?.childSolutionCodeId;
      }

      this.assignmentMandatoryFieldsInitialization();
    }

     assignmentMandatoryFieldsInitialization() {
        this.arrControlValidation = [];
        this.arrControlValidation.push(new FieldValidator('assignmentName', this.defaultEngAssignment.assignmentName, false));
        this.arrControlValidation.push(new FieldValidator('solutionCodeId', this.defaultEngAssignment.solutionCodeId, false));

        this.arrControlValidation.push(new FieldValidator('selectedengagementType',
          this.defaultEngAssignment.selectedengagementType.value, false));
        this.arrControlValidation.push(new FieldValidator('realization', this.defaultEngAssignment.realization, false));
        this.arrControlValidation.push(new FieldValidator('netFees', this.defaultEngAssignment.netFees, false));
        this.arrControlValidation.push(new FieldValidator('isContingent', this.defaultEngAssignment.isContingent, false));
        this.arrControlValidation.push(new FieldValidator('cmsEPPMDName', this.defaultEngAssignment.cmsEPPMDName, false));
        this.arrControlValidation.push(new FieldValidator('assignmentAdministrator', this.defaultEngAssignment.assignmentAdministrator, false));
        this.arrControlValidation.push(new FieldValidator('clientBillingContactName', this.defaultEngAssignment.clientBillingContactName, false));
        this.arrControlValidation.push(new FieldValidator('clientBillingContactTitleId', this.defaultEngAssignment.clientBillingContactTitleId, false));
        this.arrControlValidation.push(new FieldValidator('clientBillingContactEmail', this.defaultEngAssignment.clientBillingContactEmail, false));
        this.arrControlValidation.push(new FieldValidator('estimatedGrossMargin', this.defaultEngAssignment.estimatedGrossMargin, false));
        this.arrControlValidation.push(new FieldValidator('engagementStartDate', this.defaultEngAssignment.engagementStartDate, false));
        this.arrControlValidation.push(new FieldValidator('engagementEndDate', this.defaultEngAssignment.engagementEndDate, false));
      }

   editAssignmentDefaultValuesCheck(engagementAssignment: EngagementAssignment) {
        this.unsavedAlertfeature_DefaultAssignmentValues = JSON.parse(JSON.stringify(engagementAssignment));
  }

  ngOnDestroy() {
    this.titleService.setTitle("Engage");
    this.modalDialogRef?.unsubscribe();
  }
    invalidCharacterDetectionAssignmentName() {
    this.invalidvaluesAN = "";
    var value = this.defaultEngAssignment.assignmentName;
    const validvalues = "qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890&-_()',. ";
    for (let char of value) {
      if (validvalues.indexOf(char) === -1 && this.invalidvaluesAN.indexOf(char) === -1) {
        this.invalidvaluesAN += char;
      }
    }
  }
  refreshCMSEPPopup(index, textboxName: string) {
    this.removeRowSelection('tblEPAD', 'searchEPName', 'EPErrorMessage');
    index = this.peoplepickerIndex;
    this.CMSEPCtrl = textboxName + 'AS_' + this.epRoleName + '_' + this.peoplepickerIndex;
    // this.currentEPIndex = index;
    this.validateCMSEP = false;
    this.selectedEPIndex = null;
    this.membersListArrayForEP = null;
    if ($('#' + this.CMSEPCtrl).hasClass('text-danger')) {
      $('#' + this.CMSEPCtrl).removeClass('text-danger');
    }
  }

  refreshAssignmentEQCRPopup(currentAssignmentRowIndx: number, textboxName: string) {
    // this.currentAssignmentRowIndex = currentAssignmentRowIndx;
    // console.log('currentAssignmentRowIndex people picker', this.currentAssignmentRowIndex);
    // this.removeRowSelection('tblEQCR', 'searchAssAdminName', 'AssignmentAdminErrorMessage');

    // this.EQCRNameCtrl = textboxName + this.EQCRRoleName + '_' + this.currentAssignmentRowIndex;
    // this.EQCRCtrl = textboxName + 'AS_' + this.EQCRRoleName + '_' + this.currentAssignmentRowIndex;

    // this.selectedEQCRIndex = null;
    // this.validateEQCR = false;
    // if ($('#' + this.EQCRNameCtrl).hasClass('text-danger')) {
    //   $('#' + this.EQCRNameCtrl).removeClass('text-danger');
    // }
  }
  canDeactivate(currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return of(true);
  }

  stringCompare(field1: string, field2: string) {
    let returnVal: boolean = false;

    if (field1 == field2) {
      returnVal = true;
    }
    return returnVal;
  }

  validateConfirmEmail(clientEmailId: string) {
    const regex = /^[a-zA-Z0-9'._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/gm;
    if (regex.test(clientEmailId)) {
      return true;
    } else {
      return false;
    }
  }
  checkValidEmail(email: string) {
    const regex = /^[a-zA-Z0-9'._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/gm;
    if (regex.test(email))
      return true;
    else
      return false;
  }

    checkSpcialChar(event,) {
    if (!((event.keyCode >= 65) && (event.keyCode <= 90) || (event.keyCode >= 97) && (event.keyCode <= 122) || (event.keyCode >= 48) && (event.keyCode <= 57))) {
      return false;
    }
    return true;
  }

  checkSpaceChartBegin(event) {
    const text = event.currentTarget.value.trim();
    if (text.length === 0) {
      if (event.target.id === 'txtAssignmentName') {
        this.defaultEngAssignment.assignmentName = null;
      } else if (event.target.id === 'txtrealization') {
        this.defaultEngAssignment.realization = null;
      } else if (event.target.id === 'txtnetFees') {
        this.defaultEngAssignment.netFees = null;
      } else if (event.target.id === 'txtGrossMargin') {
        this.defaultEngAssignment.estimatedGrossMargin = null;
      } else if (event.target.id === 'txtClientBillingName') {
        this.defaultEngAssignment.clientBillingContactName = null;
      } else if (event.target.id === 'txtClientBillingEmail') {
        this.defaultEngAssignment.clientBillingContactEmail = null;
      }
      return false;
    } else if (text.length > 0) {
      this.isNewAssignmentNameDuplicate = false;
      if (event.target.id === 'txtAssignmentName') {
        this.defaultEngAssignment.assignmentName = text;

      } else if (event.target.id === 'txtrealization') {
        this.defaultEngAssignment.realization = text;
      } else if (event.target.id === 'txtnetFees') {
        this.defaultEngAssignment.netFees = text;
      } else if (event.target.id === 'txtGrossMargin') {
        this.defaultEngAssignment.estimatedGrossMargin = text;
      } else if (event.target.id === 'txtClientBillingName') {
        this.defaultEngAssignment.clientBillingContactName = text;
      } else if (event.target.id === 'txtClientBillingEmail') {
        this.defaultEngAssignment.clientBillingContactEmail = text;
      }
    } else { return true; }
  }

  mandatoryFieldInitialization() {
      this.arrControlValidation = [];
      this.arrControlValidation.push(new FieldValidator('assignmentName', this.defaultEngAssignment.assignmentName, false));
      this.arrControlValidation.push(new FieldValidator('solutionCodeId', this.defaultEngAssignment.solutionCodeId, false));
      this.arrControlValidation.push(new FieldValidator('selectedengagementType',
        this.defaultEngAssignment.selectedengagementType.value, false));
      this.arrControlValidation.push(new FieldValidator('realization', this.defaultEngAssignment.realization, false));
      this.arrControlValidation.push(new FieldValidator('netFees', this.defaultEngAssignment.netFees, false));
      this.arrControlValidation.push(new FieldValidator('isContingent', this.defaultEngAssignment.isContingent, false));
      this.arrControlValidation.push(new FieldValidator('cmsEPPMDName', this.defaultEngAssignment.cmsEPPMDName, false));
      this.arrControlValidation.push(new FieldValidator('assignmentAdministrator', this.defaultEngAssignment.assignmentAdministrator, false));
      this.arrControlValidation.push(new FieldValidator('clientBillingContactName', this.defaultEngAssignment.clientBillingContactName, false));
      this.arrControlValidation.push(new FieldValidator('clientBillingContactTitleId', this.defaultEngAssignment.clientBillingContactTitleId, false));
      this.arrControlValidation.push(new FieldValidator('clientBillingContactEmail', this.defaultEngAssignment.clientBillingContactEmail, false));
      this.arrControlValidation.push(new FieldValidator('estimatedGrossMargin', this.defaultEngAssignment.estimatedGrossMargin, false));
      this.arrControlValidation.push(new FieldValidator('engagementStartDate', this.defaultEngAssignment.engagementStartDate, false));
      this.arrControlValidation.push(new FieldValidator('engagementEndDate', this.defaultEngAssignment.engagementEndDate, false));
    }

    setAssignmentValues() {
    this.validRealization = true;
    this.validNetfees = false;
    this.validEGrossMargin = true;
    this.netFeesMessage = '';
    this.grossMarginMessage = '';
    this.RealizationMessage = '';

    this.defaultEngAssignment.solutionCodeId = $('#drpsolutionCodeId').val();
    const selectedengagementTypeId: string = $('#drpengagementTypeId').val();
    if (this.defaultEngAssignment.isContingent !== null) {
      this.defaultEngAssignment.isContingent = this.getBoolean(this.defaultEngAssignment.isContingent);
    }
    this.defaultEngAssignment.cmsEPPMDName = $('#txtPeoplePicker_AS_EP_' + this.peoplepickerIndex).val();
    this.defaultEngAssignment.cmsEPPMDEmailId = $('#UserHiddenProps_AS_EP_' + this.peoplepickerIndex + ' #hdnUserEmail').val();
    this.defaultEngAssignment.assignmentAdministrator = $('#txtPeoplePicker_AS_AA_' + this.peoplepickerIndex).val();
    this.defaultEngAssignment.adminEmailId = $('#UserHiddenProps_AS_AA_' + this.peoplepickerIndex + ' #hdnUserEmail').val();
    this.defaultEngAssignment.adminContactNo = $('#UserHiddenProps_AS_AA_' + this.peoplepickerIndex + ' #hdnUserPhone').val();
    this.defaultEngAssignment.engagementStartDate = $('.EstimatedStartDate').val();
    this.defaultEngAssignment.engagementEndDate = $('.EstimatedEndDate').val();
    this.defaultEngAssignment.dayShapeLink = $('#txtDayshapeLink').val();
    this.defaultEngAssignment.eqcrName = $('#txtPeoplePicker_AS_EQCR_' + this.peoplepickerIndex).val();
    this.defaultEngAssignment.eqcrEmailId = $('#UserHiddenProps_AS_EQCR_' + this.peoplepickerIndex + ' #hdnUserEmail').val();
    this.defaultEngAssignment.collaborationSiteId = 0;
    if (!this.empty(this.defaultEngAssignment.solutionCodeId)) {
      this.defaultEngAssignment.selectedsolutionCode =
        this.defaultEngAssignment.solutionCodeListData.find(element =>
          element.childSolutionCodeId == this.defaultEngAssignment.solutionCodeId);
    }
    else {
      this.defaultEngAssignment.solutionCodeId = null;
      this.isDisableForADV029 = false;
    }
    if (!this.empty(selectedengagementTypeId)) {
      this.defaultEngAssignment.selectedengagementType =
        this.defaultEngAssignment.engagementTypeData.find(element => element.key == selectedengagementTypeId);
    }
  }
  getBoolean(value) {
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  }
   empty(e) {
    switch (e) {
      case '':
      case 0:
      case '0':
      case null:
      case false:
      case typeof (e) == 'undefined':
        return true;
      default:
        return false;
    }
  }

  validateDate(date: any, dateName: string) {
    let isSpace = false;
    console.log("passed date is =====" + date);
    if (date === "") { isSpace = true; } else { isSpace = false; }
    let date1 = new Date(date);
    if (isNaN(date1.getTime()) && !isSpace) {
      if (dateName === 'ESD') {
        this.isvalidESD = false;
      }
      if (dateName === 'EED') {
        this.isvalidEED = false;
      }
    }
  }


  formatDate(date: any) {
    if ((date == null) || (date == undefined)) {
      // $('.engPeriodDate').val('');
      this.engagementList.plannedClosureDate = null;
      return true;
    } else {
      const formattedDate = new Date(date);
      const d = formattedDate.getDate();
      let m = formattedDate.getMonth();
      m += 1;  // JavaScript months are 0-11
      const y = formattedDate.getFullYear();
      const finalFormattedDate = (m <= 9 ? '0' + m : m) + '/' + (d <= 9 ? '0' + d : d) + '/' + y;
      if (finalFormattedDate === '1/1/1' || finalFormattedDate === '1/1/2001' ||
        finalFormattedDate == '0/0/0' || finalFormattedDate.length <= 0 || y <= 1990
        || isNaN(d) == true || isNaN(m) == true || isNaN(y) == true) {
        this.engagementList.plannedClosureDate = null;
        //  $('#txttaxYear').val('');
        return true;
      } else {
        // $('.engPeriodDate').val(finalFormattedDate);
        this.engagementList.plannedClosureDate = date;
        return false;
      }
    }
  }
  checkMandatoryValidations(fieldValidationArray, modalValidateArray, callingFrom: string = '') {
    let retVal: boolean = true;
    this.objectArray = Object.entries(modalValidateArray);
    for (let i = 0; i < fieldValidationArray.length; i++) {

      fieldValidationArray[i].setvalues(fieldValidationArray[i].fieldId,
        this.getUpdatedValue(fieldValidationArray[i].fieldId), true);
    }

    if (this.defaultEngAssignment.selectedsolutionCode.isGrossMarginRequire) {
      if (fieldValidationArray[11].fieldId == 'estimatedGrossMargin'
        && (fieldValidationArray[11].fieldValue === null ||
          fieldValidationArray[11].fieldValue === '')) {
        this.arrControlValidation[11].isvalid = false;
        this.arrControlValidation[11].apply = true;
      }
      else {
        this.arrControlValidation[11].isvalid = true;
        this.arrControlValidation[11].apply = true;
      }
    } else {
      this.arrControlValidation[11].isvalid = true;
      this.arrControlValidation[11].apply = true;
    }

    if (callingFrom === 'engagementAssignment' && fieldValidationArray.length > 3) {  //This is only for Assignmnent
      if (fieldValidationArray[3].fieldId == 'realization' && fieldValidationArray[3].fieldValue === '0') {
        fieldValidationArray[3].isvalid = true;
      }
      if (fieldValidationArray[4].fieldId == 'netFees' && fieldValidationArray[4].fieldValue === '0') {
        fieldValidationArray[4].isvalid = true;
      }
    }
     if (fieldValidationArray[2].fieldId == 'selectedengagementType' && (fieldValidationArray[2].fieldValue === '' || fieldValidationArray[2].fieldValue === '0')) {
       this.arrControlValidation[2].isvalid = false;
        this.arrControlValidation[2].apply = true;
      }
    //  //set engagement start and end date mandatory flag
    if (this.defaultEngAssignment.selectedsolutionCode.isEngagementStartDateRequired) {
      if (fieldValidationArray[12].fieldId == 'engagementStartDate'
        && (fieldValidationArray[12].fieldValue === null ||
          fieldValidationArray[12].fieldValue === undefined ||
          fieldValidationArray[12].fieldValue === '')) {

        this.arrControlValidation[12].isvalid = false;
        this.arrControlValidation[12].apply = true;
      }
      else {
        this.arrControlValidation[12].isvalid = true;
        this.arrControlValidation[12].apply = true;
      }
    } else {
      this.arrControlValidation[12].isvalid = true;
      this.arrControlValidation[12].apply = true;
    }


    if (this.defaultEngAssignment.selectedsolutionCode.isEngagementEndDateRequired) {
      if (fieldValidationArray[13].fieldId == 'engagementEndDate'
        && (fieldValidationArray[13].fieldValue === null ||
          fieldValidationArray[13].fieldValue === undefined ||
          fieldValidationArray[13].fieldValue === '')) {

        this.arrControlValidation[13].isvalid = false;
        this.arrControlValidation[13].apply = true;
      }
      else {
        this.arrControlValidation[13].isvalid = true;
        this.arrControlValidation[13].apply = true;
      }
    } else {
      this.arrControlValidation[13].isvalid = true;
      this.arrControlValidation[13].apply = true;
    }


    for (let i = 0; i < fieldValidationArray.length; i++) {
      if (!fieldValidationArray[i].isvalid) {
        retVal = false;
        break;
      }
    }
    return retVal;
  }

  checkBusinessValidations() {
    let result: boolean = false;
    let startDate = new Date(this.defaultEngAssignment.engagementStartDate);
    let currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);

    this.checkCustomValidation();
    if (this.validateAssignmentName(this.defaultEngAssignment.assignmentName)) {
      this.validAssignmentName = true;
    } else {
      this.validAssignmentName = false;
    }
    if(!this.editMode)
    this.CheckDuplicateAssignment(this.defaultEngAssignment.assignmentName);

    if (this.checkRealizationValue(this.defaultEngAssignment.realization)) {
      this.validRealization = true;
      this.RealizationMessage = '';
    } else {
      this.validRealization = false;
      this.RealizationMessage = 'Invalid realization value';
    }

    if (this.CheckRealizationValueIsGreater(this.defaultEngAssignment.realization, this.defaultEngAssignment?.selectedsolutionCode?.solutionCode)) {
      this.validRealization = true;
      this.RealizationMessage = '';
    } else {
      this.validRealization = false;
      this.RealizationMessage = 'Realization % should not be lower than the existing primary assignment realization %';
    }

    if (this.validNetfees) {
      if (this.checkDecimalValue(this.defaultEngAssignment.netFees)) {
        this.validNetfees = true;
        this.netFeesMessage = '';
      } else {
        this.validNetfees = false;
        this.netFeesMessage = 'Invalid estimated net fees value';
      }
    }
    if ($('#txtGrossMargin').val() !== '') {
      if (this.checkRealizationValue(this.defaultEngAssignment.estimatedGrossMargin)) {
        this.validEGrossMargin = true;
        this.grossMarginMessage = '';
      } else {
        this.validEGrossMargin = false;
        this.grossMarginMessage = 'Invalid estimated gross margin value';
      }
    }
    if (!this.checkValidEmail(this.defaultEngAssignment.clientBillingContactEmail)) {
      this.isInvalidClientBillingContactEmail = true;
    } else {
      this.isInvalidClientBillingContactEmail = false;
    }
    // 1 cmsEPPMDName and assignmentAdministrator should not be the same
    if (this.stringCompare(this.defaultEngAssignment.cmsEPPMDName, this.defaultEngAssignment.assignmentAdministrator)) {
      this.showHideErrorMessageDiv(true);
      result = false;
    } else {
      this.showHideErrorMessageDiv(false);
      result = true;
    }

    // 2. EPPMDName and  AassignmentAdministrator should be valid and with Azure AD
    if (result) {
      this.isvalidcmsEPPMDName = Boolean(JSON.parse($('#hdnValidInput_AS_EP_' + this.peoplepickerIndex).val()));
      this.isvalidAassignmentAdministrator = Boolean(JSON.parse($('#hdnValidInput_AS_AA_' + this.peoplepickerIndex).val()));

      if ((!this.isvalidcmsEPPMDName) ||
        (!this.isvalidAassignmentAdministrator)
      ) {
        result = false;
      } else {
        result = true;
      }
    }

    //4.IF EQCR then check its valid and is not same as CMSEP nad AA

    this.defaultEngAssignment.isvalidEQCR = true;
    this.defaultEngAssignment.isValidEQCRBusinessRule = true;
    this.defaultEngAssignment.isEQCRExists = false;

    if (this.defaultEngAssignment.eqcrName != '' && this.defaultEngAssignment.eqcrName != null &&
      this.defaultEngAssignment.eqcrName != undefined) {
      this.defaultEngAssignment.isvalidEQCR = Boolean(JSON.parse($('#hdnValidInput_AS_EQCR_' + this.peoplepickerIndex).val()));

      if (!this.defaultEngAssignment.isvalidEQCR) {
        result = false;
      }

      if (this.stringCompare(this.engagementList.engagementPartnerName, this.defaultEngAssignment.eqcrName)
        || this.stringCompare(this.defaultEngAssignment.cmsEPPMDName, this.defaultEngAssignment.eqcrName)
        || this.stringCompare(this.defaultEngAssignment.assignmentAdministrator, this.defaultEngAssignment.eqcrName)
      ) {
        this.defaultEngAssignment.isValidEQCRBusinessRule = false;
        result = false;
      }
    }

    this.DateCompareResult = this.compareDate(new Date(this.defaultEngAssignment.engagementStartDate), new Date(this.defaultEngAssignment.engagementEndDate))

    if ((result !== this.validRealization) || (result !== this.validNetfees) || (result !== this.validEGrossMargin)) {
      result = false;
    }
    if (this.DateCompareResult === 0 || this.DateCompareResult > 0) {
      result = false;
    }
    if (this.isNewAssignmentNameDuplicate) {
      result = false;
    }
    if (!this.validAssignmentName) {
      result = false;
    }
    this.startDateCompareResult = this.compareDate(currentDate, startDate);
    if (this.startDateCompareResult > 0) {
      result = false;
    }

    this.yearValidationResult = this.checkYearValidations(new Date(this.defaultEngAssignment.engagementStartDate), new Date(this.defaultEngAssignment.engagementEndDate));
    if(this.yearValidationResult > 0) {
      result = false;
    }

    return result;
  }

  checkCustomValidation() {
    if (
      this.defaultEngAssignment.isContingent === true &&
      this.defaultEngAssignment.netFees != 0) {
      this.validNetfees = false;
      this.netFeesMessage = 'Estimated net fees should be 0 for contingent assignment';
    } else {
      this.validNetfees = true;
      this.netFeesMessage = '';
    }
  }

  checkRealizationValue(str) {
    const regex = /^((0|[0-9]\d?)|100?)$/gm;
    if (regex.test(str)) {
      return true;
    } else {
      return false;
    }
  }

  checkDecimalValue(str) {
    const regex = new RegExp('^[0-9]+(\.[0-9]{1,4})?$');
    if (regex.test(str)) {
      return true;
    } else {
      return false;
    }
  }

  showHideErrorMessageDiv(flag: boolean) {
    const div = 'businessMessageForAdministratorsDiv';
    if (flag) {
      if ($('#' + div).is(':hidden')) {
        $('#' + div).show();
      }
    } else {
      if ($('#' + div).is(':visible')) {
        $('#' + div).hide();
      }
    }
  }

   private checkYearValidations(date1: Date, date2: Date): number {

    let startDate = new Date(date1);
    let endDate = new Date(date2);

    // Start Date should be within 13 months from current date
    let maxStartDateVal = new Date();
    maxStartDateVal.setMonth(maxStartDateVal.getMonth() + 13)


    // End date should be within 5 years from start date.
    let maxEndDateVal = new Date(date1);
    maxEndDateVal.setFullYear(maxEndDateVal.getFullYear() +5)


    if(startDate > maxStartDateVal && endDate > maxEndDateVal ) return 1;
    else if (startDate > maxStartDateVal) return 2
    else if (endDate > maxEndDateVal )return 3
    else return 0

  }


  private compareDateString(date1: string, date2: string): number {
    // With Date object we can compare dates them using the >, <, <= or >=.
    // The ==, !=, ===, and !== operators require to use date.getTime(),
    // so we need to create a new instance of Date with 'new Date()'
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    // Check if the dates are equal
    const same = d1.getTime() === d2.getTime();
    if (same) {
      return 0;
    }

    // Check if the first is greater than second
    if (d1 > d2) {
      return 1;
    }

    // Check if the first is less than second
    if (d1 < d2) {
      return -1;
    }
  }

   saveAssignment(assignmentrowid: string) {
    this.isvalidEED = true;
    this.isAllValidatedPassedOfAddassignment = false;
    this.isvalidESD = true;

    this.defaultEngAssignment.assignmentName = (this.defaultEngAssignment.assignmentName ?? '').trim(); // Whitespace-only (and null/undefined) collapse to '' before any validation
    this.defaultEngAssignment.clientBillingContactName = (this.defaultEngAssignment.clientBillingContactName ?? '').trim();

    this.mandatoryFieldInitialization();
     this.setAssignmentValues();
    this.validateDate(this.defaultEngAssignment.engagementStartDate, 'ESD');
    this.validateDate(this.defaultEngAssignment.engagementEndDate, 'EED');

      if (this.defaultEngAssignment.assignmentName !== '') {
      this.engagementService.GetAssignmentNameCountByClientId(this.defaultEngAssignment.assignmentName, this.engagementList.clientId).subscribe(count => {
        if (count > 0 && !this.editMode) {
          this.isAssignmentNameExistForClient = true;
        } else {
          this.isAssignmentNameExistForClient = false;
        }
        if (this.checkMandatoryValidations(this.arrControlValidation, this.defaultEngAssignment, 'engagementAssignment')
          && this.isvalidESD && this.isvalidEED) {

          if (this.checkBusinessValidations() && !this.isAssignmentNameExistForClient && !this.isInvalidClientBillingContactEmail) {

            this.setAssignmentValuesBeforeSave();
            if (this.arrEngagementAssignment.length >= 0) {
              this.isAllValidatedPassedOfAddassignment = true;
              this.AddAssignment();
            }
            this.cmsDisplayUserEmail = '';
            this.cmsDisplayUserName = '';
            this.adminDisplayUserName = '';
            this.adminDisplayUserEmail = '';
            this.validateCMSAA = false;
            this.validateCMSEP = false
            setTimeout(() => {
            this.hideDefaultAssignmentBox();
            }, 0);
          }
        }
      });
    } else if (this.checkMandatoryValidations(this.arrControlValidation, this.defaultEngAssignment, 'engagementAssignment')
          && this.isvalidESD && this.isvalidEED){

   }
  }

  // request Assignment Code from cms
    requestAssignmentCode(workspaceId: string, assignmentCodeId: number, newAssignmentName: string, index: number, eSignResponse: EngagementESignature) {
      this.loadingScreenService.startLoading();

      //let processAssignmentFlag = false;
      console.log(workspaceId, assignmentCodeId, newAssignmentName, index);
      if (workspaceId === null && assignmentCodeId === null) {
        console.log('Cannot process the CMS Request as no valid values found.');
        this.cmsCodeRequestError = true;
        if (!this.clmLsDownloadFileFromSharepoitisRunning)
          this.loadingScreenService.stopLoading();
      } else {

        let _workspaceId = '';
        let _assignmentCodeId = 0;
        let _isAcceptanceRequest = 0;

        if (assignmentCodeId != null) {
          _workspaceId = null;
          _assignmentCodeId = assignmentCodeId;
          _isAcceptanceRequest = 0;
        } else {
          _workspaceId = workspaceId;
          _assignmentCodeId = 0;
          _isAcceptanceRequest = 1;
        }

        this.workspaceService.CheckRequestSentForClient(_workspaceId, _assignmentCodeId, _isAcceptanceRequest).subscribe(processAssignmentFlagStatus => {
          if (processAssignmentFlagStatus == 1) {
            let engagementWorkspaceId = workspaceId;
            let engagementAssignmentCodeId = assignmentCodeId;
            let _assignmentName = newAssignmentName;

            this.workspaceService.getPrimaryAssignment(engagementWorkspaceId, engagementAssignmentCodeId, _assignmentName).subscribe(
              assignmentRequestList => {
                for (const assignmentRequest of assignmentRequestList) {
                  console.log('data from getPrimaryAssignment ', assignmentRequest);

                  if (!this.checkUserExistance(assignmentRequest.initiated_By_Email)) {
                    this.employeeList.push(new Employee('0', assignmentRequest.initiated_By_Email));
                  }
                  if (!this.checkUserExistance(assignmentRequest.client_Administrator_Email)) {
                    this.employeeList.push(new Employee('0', assignmentRequest.client_Administrator_Email));
                  }
                  if (!this.checkUserExistance(assignmentRequest.assignment_Administrator_Email)) {
                    this.employeeList.push(new Employee('0', assignmentRequest.assignment_Administrator_Email));
                  }
                  if (!this.checkUserExistance(assignmentRequest.engagement_Partner_Email)) {
                    this.employeeList.push(new Employee('0', assignmentRequest.engagement_Partner_Email));
                  }
                }

                console.log('To get the employee ids for given user list ', this.employeeList);
                const searchEmployee = new SearchEmployeeModel();
                searchEmployee.employees = this.employeeList;

                this.graphSerivce.GetEmployeeIdForUserList(searchEmployee).subscribe(
                  finalEmployeeList => {

                    console.log('API response for employee ids for given user list ', finalEmployeeList);
                    for (const assignmentRequestInner of assignmentRequestList) {
                      assignmentRequestInner.initiated_By
                        = finalEmployeeList.find(item => item.employeeEmailId === assignmentRequestInner.initiated_By_Email)
                          .employeeId;
                      assignmentRequestInner.client_Administrator
                        = finalEmployeeList.find(item => item.employeeEmailId === assignmentRequestInner.client_Administrator_Email)
                          .employeeId;
                      assignmentRequestInner.assignment_Administrator
                        = finalEmployeeList.find(item => item.employeeEmailId === assignmentRequestInner.assignment_Administrator_Email)
                          .employeeId;
                      assignmentRequestInner.engagement_Partner
                        = finalEmployeeList.find(item => item.employeeEmailId === assignmentRequestInner.engagement_Partner_Email)
                          .employeeId;

                      console.log('Updated Assignment Request ', assignmentRequestList);
                    }
                    const request = this.convertAssignmentRequestListToCreateAssignmentRequest(assignmentRequestList);
                    this.cmsService.PostPrimaryAssignmentFinance(request).subscribe(
                      assignmentResponse => {
                        console.log('Successfully submission of CMS Primary Assignment.', assignmentResponse);
                        let assignmentResponseList = new AssignmentResponseList();
                        assignmentResponseList.list = [];
                        for (const item of assignmentResponse.data.assignmentResponse) {
                          let assignmentResponseLog = new AssignmentResponse();
                          assignmentResponseLog.assignmentCodeId = item.assignmentCodeId;
                          assignmentResponseLog.responseStatus = item.responseStatus;
                          assignmentResponseLog.api = assignmentResponse.engageFinanceIntegrationDetail?.endpoint;
                          assignmentResponseLog.requestBody = assignmentResponse.engageFinanceIntegrationDetail?.requestBody;
                          assignmentResponseLog.responseBodyForMoreThanOneAssignment = assignmentResponse.engageFinanceIntegrationDetail?.responseBody;
                          assignmentResponseLog.errorDetail = item.errorDetail;
                          assignmentResponseLog.requestDate = assignmentResponse.engageFinanceIntegrationDetail?.requestDateTime;
                          assignmentResponseLog.responseDate = assignmentResponse.engageFinanceIntegrationDetail?.responseDateTime;
                          assignmentResponseLog.requestBy = this.userObject.loggedInUserEmail;
                          assignmentResponseLog.requestStatus = assignmentResponse.engageFinanceIntegrationDetail?.requestStatus;
                          assignmentResponseList.list.push(assignmentResponseLog);
                        }
                        this.workspaceService.storeFinanceLog(assignmentResponseList).subscribe(
                          logResult => {

                            for (let i = 0; i < assignmentResponse.data.assignmentResponse.length; i++) {
                              this.workspaceService
                                .updateFirstAssignmentStatus(assignmentResponse.data.assignmentResponse[i].responseStatus, assignmentResponse.data.assignmentResponse[i].assignmentCodeId)
                                .subscribe(
                                  statusResult => { console.log(statusResult); }
                                );
                            }

                            if (eSignResponse != null && eSignResponse.envelopeStatusValue == "Completed") {
                              this.workspaceService.UpdateEngagementStatusOnSignatureCompletion(this.engagementId).subscribe(
                                finalUpdateStatus => {
                                  console.log(finalUpdateStatus);
                                  //this.getEngagementCollaborationsById(this.engagementId, false);
                                }
                              )
                            }

                            this.loadingScreenService.stopLoading();
                            this.arrEngagementAssignment[index].assignmentCodeStatus = this.AssignmentCodeRequested;

                          },
                          logError => {
                            this.loadingScreenService.stopLoading();
                            console.error('Error in getting the response in storeFinanceLog in Engage API ', logError);
                          }

                        );
                      },
                      error => {
                        this.loadingScreenService.stopLoading();
                        console.error('Error in getting the response in PostPrimaryAssignmentFinance in Finance Integration API ', error);
                      }
                    );
                  },
                  error => {
                    this.loadingScreenService.stopLoading();
                    console.error('Error in getting the response in GetEmployeeIdForUserList in Graph API ', error);
                  }
                );
              },
              error => {
                this.loadingScreenService.stopLoading();
                console.error('Error in getting the response in getPrimaryAssignment in API ', error);
              }
            );

          } else {
            if (processAssignmentFlagStatus == 2) {
              const message = "Invalid case CMS Request cannot be sent.";
              console.error(message);
              this.workspaceService.storeErrorLog(message + "::" + this.userObject);
            }
            this.loadingScreenService.stopLoading();
          }
        },
          err => {
            this.loadingScreenService.stopLoading();

            console.error('Error in CheckRequestSentForClient ', err);
          });
      }
    }
    // end request assignment code from cms

    // end request assignment code from cms

  checkUserExistance(email: string): boolean {
    return this.employeeList.some(r => r.employeeEmailId === email);
  }
  // end assignment tab section

setUnsavedChangesForIwantTo() {
    if (!this.unsavedAlertfeature_IsSaveChangesOrNextBtnClicked) {
      if (this.unsavedAlertfeature_AnyFormFieldChanged) {
        const dialogData = {
          fromComponent: 'engagement',
          isUnsavedChangesExist: true
        };
        const dialogJSON = JSON.stringify(dialogData);
        this.dataService.setUnsavedChangesModel(dialogJSON);
      }
    }
  }
  updateAssignment() {
      if (this.arrEngagementAssignment.length > 0) {
        this.unsavedAlertfeature_AnyFormFieldChanged = true;
        this.setUnsavedChangesForIwantTo();
        // if (this.engagement.preRequestForContinuance == false || this.engagement.preRequestForContinuance == undefined) {
        this.defaultEngAssignment.status = this.defaultEngAssignment.assignmentCodeId == 0 ? 'Add' : 'Update'


      }


    }

assignAzureADGroupsByMemberFirm() {
    if (this.azureADUsersArrayListMemberFirm == undefined) {
      let role;
      if (this.currentCollabModel.currentCollaborationSiteViewModel.collaborationSite.isIndus) {
        role = this.memberFirmData.indusConsentShortRoleName;
      } else {
        role = this.memberFirmData?.teamMemberShortRoleName;
      }
      this.adUsersService.GetAzureADGroupsByRoleShortName(role).subscribe(
        result => {
          this.azureADUsersArrayListMemberFirm = result;
          this.azureADUsersArrayListMemberFirm.azureADUsers?.forEach(resu => {
            this.assignAdminList.azureADUsers.push(resu);
          });
          this.assignAzureADGroupsByAdmin();
        }
      );
    }
    else {
      this.azureADUsersArrayListMemberFirm.azureADUsers?.forEach(resu => {
        this.assignAdminList.azureADUsers.push(resu);
      });
      this.assignAdminList.azureADUsers = this.assignAdminList.azureADUsers.filter((item,
        index) => this.assignAdminList.azureADUsers.indexOf(item) === index);
    }
  }

  assignAzureADGroupsByAdmin() {
    if (this.isloggedInUserAdmin == 'yes' && this.memberFirmData?.memberFirmMappingId != undefined) {
      if (this.azureADUsersArrayListAdmin == undefined)
        this.adUsersService.GetAzureADGroupsByRoleShortName(RoleNames.StaffMember.toString()).subscribe(
          result => {
            this.azureADUsersArrayListAdmin = result;
            this.azureADUsersArrayListAdmin.azureADUsers?.forEach(resu => {
              this.assignAdminList.azureADUsers.push(resu);
            });
            this.assignAdminList.roleName = RoleNames.StaffMember.toString();
          }
        );
      else {
        this.azureADUsersArrayListAdmin.azureADUsers?.forEach(resu => {
          this.assignAdminList.azureADUsers.push(resu);
        });
        this.assignAdminList.roleName = RoleNames.StaffMember.toString();
      }
    }
  }
  clickOnSelectedClient(){
    alert('hello');
  }
  AddAssignment() {
      this.loadingScreenService.startLoading();
      this.defaultEngAssignment.isPrimaryAssignment = false;
      let addedAssignmentCodeId = 0;
      // this.defaultEngAssignment.assignmentCode = null;
      this.newEngAssignment = {
        engagementId: this.engagementList.engagementId,
        assignmentCodeId: this.defaultEngAssignment.assignmentCodeId,
        solutionCodeId: this.defaultEngAssignment.solutionCodeId,
        assignmentName: this.defaultEngAssignment.assignmentName,
        assignmentAdministrator: this.defaultEngAssignment.assignmentAdministrator,
        realization: this.defaultEngAssignment.realization,
        netFees: this.defaultEngAssignment.netFees,
        createdBy: this.defaultEngAssignment.createdBy,
        createdDate: this.defaultEngAssignment.createdDate,
        lastModifiedBy: this.defaultEngAssignment.lastModifiedBy,
        lastModifiedDate: this.defaultEngAssignment.lastModifiedDate,
        adminEmailId: this.defaultEngAssignment.adminEmailId,
        adminContactNo: this.defaultEngAssignment.adminContactNo,
        assignmentCode: this.defaultEngAssignment.assignmentCode,
        cmsEPPMDName: this.defaultEngAssignment.cmsEPPMDName,
        cmsEPPMDEmailId: this.defaultEngAssignment.cmsEPPMDEmailId,
        engagementTypeId: this.defaultEngAssignment.engagementTypeId,
        isContingent: this.defaultEngAssignment.isContingent,
        isPrimaryAssignment: this.defaultEngAssignment.isPrimaryAssignment,
        collaborationSiteId: '',
        engagementStartDate: this.defaultEngAssignment.engagementStartDate,
        engagementEndDate: this.defaultEngAssignment.engagementEndDate,
        officeLocationCodeId: this.defaultEngAssignment.officeLocationCodeId,
        estimatedGrossMargin: this.defaultEngAssignment.estimatedGrossMargin,
        clientBillingContactName: this.defaultEngAssignment.clientBillingContactName,
        clientBillingContactTitleId: this.defaultEngAssignment.clientBillingContactTitleId,
        clientBillingContactEmail: this.defaultEngAssignment.clientBillingContactEmail,
        eqcrName: this.defaultEngAssignment.eqcrName,
        eqcrEmailId: this.defaultEngAssignment.eqcrEmailId,
        opportunityServiceId: this.defaultEngAssignment.opportunityServiceId,
        opportunityId: this.defaultEngAssignment.opportunityId,
        opportunityName: this.defaultEngAssignment.opportunityName,
        dayShapeLink: this.defaultEngAssignment.dayShapeLink,
        isChangeOrderAssignment: this.defaultEngAssignment.isChangeOrderAssignment

      };
      if(!this.editMode){
      this.engagementAssignmentWithoutSCode.push(this.newEngAssignment);
      this.engAssignmentData = [];
      console.log(this.engagementAssignmentWithoutSCode);
      this.engAssignmentData.push(this.newEngAssignment);
      } else{
      this.engAssignmentData = [];
      this.engAssignmentData.push(this.newEngAssignment);
      }
      this.setAssignmentSection();
      this.loadingScreenService.stopLoading();
    }


      enableDraggable(tabClick: boolean) {
    $('.div-sortable').sortable({
      placeholderClass: 'list-group-item',
      connectWith: '.connected'
    });
    setTimeout(() => {
      // check assignment count per collaboration then disable drag-drop behavior when count is 1.
      // when count > 1 then check other conditions for disabling drag-drop behavior.
      const collabDiv = $('#collaborationSiteList');
      const collabs = $(collabDiv).children();
      let makeDisable = false;
      let assignmentCode = null;
      for (let i = 0; i < collabs.length; i++) {
        let collabAssignments = $($(collabs[i]).children()).closest('.div-sortable').children().closest('.assignmentsection');
        let noAssignmentLabel = $($(collabs[i]).children()).closest('.div-sortable').children().closest('.noAssignment');
        if (noAssignmentLabel !== undefined && noAssignmentLabel.length > 0) {
          $(noAssignmentLabel).attr('draggable', 'false');
        }
      //   console.log('collabAssignments=>', collabAssignments);
      //   if (collabAssignments !== undefined && collabAssignments.length > 0) {
      //     if (collabAssignments.length === 1) {
      //       $(collabAssignmefnts).attr('draggable', 'false');
      //     } else if (collabAssignments.length > 1) {

      //       if (this.collaborationSiteList[i].isLoggedInUserPartOfCollaboration == false) {
      //         makeDisable = true;
      //       }
      //
      //       if (makeDisable) {
      //         for (let c = 0; c < collabAssignments.length; c++) {
      //           $(collabAssignments[c]).attr('draggable', 'false');
      //         }
      //       }
      //       else {
      //         for (let c = 0; c < collabAssignments.length; c++) {
      //           assignmentCode = $(collabAssignments[c]).find('#hdnAssignmentCode').val();

      //           if (!assignmentCode || assignmentCode.toString().trim().length == 0) {
      //             $(collabAssignments[c]).attr('draggable', 'false');
      //           }
      //           else {
      //             $(collabAssignments[c]).attr('draggable', 'true');
      //             $(collabAssignments[c]).addClass('list-group-item');
      //           }
      //         }
      //       }
      //     } // end if collabAssignments.length > 1
      //   } // end if collabAssignments.length > 0
       } // end for loop collabs.length
      if (tabClick === true) {
        this.isPageLoad = false;
      }
    }, 500);
  }

  CallUpdatePermissions(updatePermissionsModeList: UpdatePermissionsModel[]) {
      let updatePermissionsModelData: UpdatePermissionsModelData = new UpdatePermissionsModelData();
      updatePermissionsModelData.updatePermissionsModel = updatePermissionsModeList;
      this._activedirectoryService.UpdatePermissions(updatePermissionsModelData).subscribe(
        result => {
          if(this.editMode && this.changeOrderId > 0)
          this.router.navigate(['Interviews/' + this.changeOrderWorkspaceId]);
         else
             this.router.navigate(['Interviews/' + this.workspaceId]);

        },
        error => {
          this.loadingScreenService.stopLoading();
          this._alertService.add('Something went wrong! Please contact system administrator.', 'danger', null);
        });
    }

  // Start - Restrict First assignmentsection Row for drag and drop
  DisableDragDropSingleAssignment() {
    var arrCurrentCollaboration = $('.currentCollaboration');
    var assignmentsectionDiv = $($(arrCurrentCollaboration[0]).children()).closest('.div-sortable').children().closest('.assignmentsection');

    var firstAssignmentsectionDivtlength = assignmentsectionDiv.length;
    var assignmentsectionDivChildrens = $(assignmentsectionDiv.children())
    var myDivClasses = assignmentsectionDivChildrens[1] ? assignmentsectionDivChildrens[1].classList : '';

    if (firstAssignmentsectionDivtlength == 1) {
      console.log('myDivClasses', myDivClasses);
      if (myDivClasses.contains("list-group-item")) {
        myDivClasses.remove("list-group-item");
      }
      assignmentsectionDiv[0].draggable = false;
      assignmentsectionDivChildrens.find("img").css({ "display": "none" });
      console.log('length is one', firstAssignmentsectionDivtlength);
    }
  }



  CheckRealizationValueIsGreater(realization: number, solutionCode: string) {
    let result: boolean = false;
    let maxRealization: number = 0;
    if (solutionCode != null && solutionCode != "" && solutionCode != undefined
      && this.engagementList?.status != null && this.engagementList?.status != ""
      && this.engagementList?.status != undefined && solutionCode === "ADV029" &&
      (this.engagementList?.status?.toLocaleLowerCase() === "active" ||
        this.engagementList?.status?.toLocaleLowerCase() === "active (pending cms codes)" ||
        this.engagementList?.status?.toLocaleLowerCase() === "active (pending signature)")) {
      result = true;
    } else {
      for (let i = 0; i < this.engagementAssignmentList.length; i++) {
        if (this.engagementAssignmentList[i].isPrimaryAssignment) {
          maxRealization = this.engagementAssignmentList[i].realization;
        }
      }
      result = (maxRealization <= realization) ? true : false;
    }
    result = true;
    return result;
  }
  getUpdatedValue(id: string) {
    let retval: any = '';

    this.objectArray.forEach(([key, Keyvalue]) => {
      if (key == id) {
        switch (key) {
          case 'selectedengagementType':
            retval = Keyvalue.value;
            break;
          case 'selectedsolutionCode':
            retval = Keyvalue.childSolutionCodeId;
            break;
          case 'solutionCodeId':
            if (Keyvalue == null) {
              retval = Keyvalue;
            } else {
              retval = Keyvalue.value
            }
            break;
          case 'isContingent':
            if (Keyvalue == null) {
              retval = Keyvalue;
            } else {
              retval = Boolean(Keyvalue);
            }
            break;
          default:
            retval = Keyvalue;
            break;
        }
      }
    });
    return retval;
  }

  resetDefaultAssignment() {
    this.resetAssignmentModel();
    this.hideDefaultAssignmentBox();
  }
  resetAssignmentModel() {
    this.controlInitialization();
    setTimeout(() => {
      this.hideDefaultAssignmentBox();
    }, 0);
  }
  CheckDuplicateAssignment(newAssignmentName: string) {
    for (let i = 0; i < this.engagementAssignmentList.length; i++) {
      if (this.engagementAssignmentList[i].assignmentName.toLowerCase() == newAssignmentName.toLowerCase()) {
        this.isNewAssignmentNameDuplicate = true;
        break;
      } else {
        this.isNewAssignmentNameDuplicate = false;
      }
    }
  }

  hideDefaultAssignmentBox() {
    this.isVisibledefaultAssignmentDiv = false;
  }
  controlInitialization() {
      this.isvalidAassignmentAdministrator = true;
      this.isvalidSignatureHandler = true;
      this.defaultEngAssignment.cmsEPPMDName = $('#txtPeoplePicker_AS_EP_0').val();
      this.defaultEngAssignment.cmsEPPMDEmailId = $('#UserHiddenProps_AS_EP_0 #hdnUserEmail').val();
      this.defaultEngAssignment.isPrimaryAssignment = false;
      this.defaultEngAssignment.netFees = null;
      this.defaultEngAssignment.realization = null;
      this.defaultEngAssignment.engagementTypeId = '0';
      const defaultengagementType = new KeyValue();
      defaultengagementType.key = '';
      defaultengagementType.value = '';
      this.defaultEngAssignment.selectedengagementType = defaultengagementType;
      this.defaultEngAssignment.isContingent = null;
      this.defaultEngAssignment.cmsEPPMDName = ''
      this.defaultEngAssignment.cmsEPPMDEmailId = ''
      this.defaultEngAssignment.adminContactNo = '';
      this.defaultEngAssignment.assignmentAdministrator = '';
      this.defaultEngAssignment.assignmentName = '';
      this.defaultEngAssignment.collaborationSiteId = null;
      this.defaultEngAssignment.engagementStartDate = null;
      this.defaultEngAssignment.engagementEndDate = null;
      this.defaultEngAssignment.officeLocationCodeId = 0;
      this.defaultEngAssignment.estimatedGrossMargin = null;
    }

  setAssignmentValuesBeforeSave() {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0
    })
    this.defaultEngAssignment.netFeesInCurrencyFormat = formatter.format(Number(this.defaultEngAssignment.netFees));
    this.defaultEngAssignment.estimatedGrossMarginInCurrencyFormat =
      (this.defaultEngAssignment.estimatedGrossMargin == null)
        ? ''
        : formatter.format(Number(this.defaultEngAssignment.estimatedGrossMargin));
  }


  initializeAssignmentDetails(){
    // this.InitializeMasterDataForAssignmentSecion(this.source);
    // this.GetContactTypes();
    // this.GetClientLocations();
    setTimeout(() => {
      this.getEngagementCollaborationsById(this.engagementId);
    }, 1000);
  }

 getEngagementCollaborationsById(engId: number, isLoadDefaultTab: boolean = true) {
     this.loadingScreenService.startLoading();
     return this.engagementService.getEngagementCollaborationsById(engId, this.isLoggedInUserSystemAdmin?'yes':'no')
       .subscribe(
         result => {
           this.engagementCollaborationsViewModel = result;
           this.engagementList = this.engagementCollaborationsViewModel.engagement;
            this.collaborationSiteList = this.engagementCollaborationsViewModel.collaborationSiteList;
            this.collaborationSiteMembersList = this.engagementCollaborationsViewModel.collaborationSiteMembersList;
           this.titleService.setTitle(`Engage | ${this.engagementList.clientName} -  ${this.engagementList.engagementName}`)
           if (this.engagementList.engagementId > 0 && this.engagementList.clientId > 0 &&
             this.engagementList.status != 'Closed' && this.engagementList.status != 'Voided') {
             this.dataService.setClientIdForPrePopulate(this.engagementList.clientId);
             this.dataService.setEngagementIdForPrePopulate(this.engagementList.engagementId);
           }


           if (this.secondarySolutionCodeList != undefined && this.secondarySolutionCodeList.length > 0) {
             this.defaultEngAssignment.solutionCodeListData = this.secondarySolutionCodeList;
             this.defaultEngAssignment.solutionCodeId =  this.secondarySolutionCodeList.find(s => s.childSolutionCodeId == this.defaultEngAssignment.solutionCodeId)?.childSolutionCodeId;
           }

            this.isDisableSolutionCode = true;
            this.defaultEngAssignment.iscontingentData = this.contingentkeyValueList,
            this.defaultEngAssignment.engagementTypeData  = this.engtypekeyValueList
            $('#drpengagementTypeId').val(this.defaultEngAssignment.engagementTypeId);
            $('#ddClosestGTOffice').val(this.defaultEngAssignment.officeLocationCodeId);
            $('#UserHiddenProps_AS_AA_0 #hdnUserPhone').val(this.defaultEngAssignment.adminContactNo);
            if (this.defaultEngAssignment.isContingent !== null) {
             this.defaultEngAssignment.isContingent = this.getBoolean(this.defaultEngAssignment.isContingent);
            //  $('#drpisContingent').val(this.defaultEngAssignment.isContingent);
            }
            $('#txtDayshapeLink').val(this.defaultEngAssignment.dayShapeLink);
            $('.EstimatedStartDate').val(this.datePipe.transform(this.defaultEngAssignment.engagementStartDate, 'MM/dd/yyyy'));
            $('.EstimatedEndDate').val(this.datePipe.transform(this.defaultEngAssignment.engagementEndDate, 'MM/dd/yyyy'));
          if(!this.editMode && !this.isEditAssignmentClicked){
            //this.objectInitialization();
            this.getDefaultClientBillingContactDetails(this.engagementList.clientId);
          }
           this.getClientMemberPermissions();
           this.getTeamMemberRoles();
           this.getTeamMemberRoleList(); // from appmaster getting all field values to compare on UI and team member addition
           this.getKeyTeamMemberRoleList(); // from appmaster getting all field values to compare on UI and key team member addition

           //When Engagement status is CMS Code Error or closed block user to perform actions
           if (this.engagementList.status === EngagementStatus.EngCmsCodeError ||
             this.engagementList.status === EngagementStatus.EngClosed ||
             this.engagementList.status === EngagementStatus.EngVoided) {
           }
           if (((this.engagementList.status === EngagementStatus.EngActive ||
             this.engagementList.status === EngagementStatus.EngActivePendingCMSCode ||
             this.engagementList.status === EngagementStatus.EngActivePendingSignature)
             && this.engagementAssignmentList.length === 1) ||
             !(this.engagementList.status === EngagementStatus.EngActive ||
               this.engagementList.status === EngagementStatus.EngActivePendingCMSCode ||
               this.engagementList.status === EngagementStatus.EngActivePendingSignature
             )
           ) {
             this.isDisableAddCollaborationSite = true;
           } else {
             if (this.newCollabrationCount > 0) {
               this.isDisableAddCollaborationSite = true;
             }
             else {
               this.isDisableAddCollaborationSite = false;
             }
           }
           //When logged in user belong s to quality group block user to perform action
           this.blockUserAction();

           this.loadingScreenService.stopLoading();
         },
         error => {
           this.engagementList = null;
           this.loadingScreenService.stopLoading();
           this.alertServiceFun('You do not have access to view details !', 'danger');
         }
       );
   }

    getClientMemberPermissions() {
       this.applicationMasterService.GetClientMemberPermissions().subscribe(
         result => {
           this.clientMemberPermissions = result;
           this.clientMemberPermissionModelList = [];
           this.clientMemberPermissions.forEach(pr => {
             let codeValueArr = pr.typeValue.split('|');
             let tempModel: ClientMemberPermissionModel = new ClientMemberPermissionModel();
             tempModel.id = pr.id;
             tempModel.code = codeValueArr[0];
             tempModel.typeValue = codeValueArr[1];
             this.clientMemberPermissionModelList.push(tempModel);
             if (codeValueArr[0] === 'R') {
               this.defaultClientPermissionId = pr.id;
             }
           })

           console.log('clientMemberPermissionModelList', this.clientMemberPermissionModelList);
         }
       );
     }

    blockUserAction() {
       console.log('blockUserAction');
       if (this.isQualityUserLoggedIn === true && this.isloggedInUserAdmin == 'no' &&
        // !this.currentCollabModel.currentCollaborationSiteViewModel.collaborationSite.isLoggedInUserPartOfCollaboration &&
         this.engagementList.status != EngagementStatus.EngCmsCodeError &&
         this.engagementList.status != EngagementStatus.EngClosed &&
         this.engagementList.status != EngagementStatus.EngVoided) {
       }
  }

   getDefaultClientBillingContactDetails(clientId: number) {
    return this.clientService.getDefaultClientBillingContactDetails(clientId)
      .subscribe(
        result => {
          this.defaultClientBillingContact = result;
          //to set client contact billing details
          this.setClientBillingContactDetails();
        },
        error => {
        }
      );
  } // end getDefaultClientBillingContactDetails

  setClientBillingContactDetails() {
    //Client Billing contact details
    if (this.engagementList.clientId > 0) {
      if ((this.defaultClientBillingContact.clientBillingEmail !== undefined || this.defaultClientBillingContact.clientBillingEmail !== null) ||
        (this.defaultClientBillingContact.clientBillingName !== undefined || this.defaultClientBillingContact.clientBillingName !== null)) {
        this.defaultEngAssignment.clientBillingContactEmail = this.defaultClientBillingContact.clientBillingEmail;
        this.defaultEngAssignment.clientBillingContactName = this.defaultClientBillingContact.clientBillingName;

      }
      if (this.defaultClientBillingContact.clientBillingTitleId > 0) {
        this.defaultEngAssignment.clientBillingContactTitleId = this.defaultClientBillingContact.clientBillingTitleId;
      }
    }
  } // end setClientBillingContactDetails

  validateAssignmentName(name: string) {
    const regex = /^[A-Za-z0-9()',&._-\s]*$/gm;
    if (regex.test(name)) {
      return true;
    } else {
      return false;
    }
  }

  checkPrefillClientAndEngagement() {
    let prevPath = this.dataService.previousUrl.getValue();
    if (prevPath?.includes("EngagementDetail") && !(this.changeOrderId > 0)) {
      let pathItems = prevPath.split("/");
      let engagementIdTemp = +pathItems[2];
      this.engagementId = +engagementIdTemp;
      this.isPrepopulateFromDetails = true;
      this.getEngagementDetailsById(engagementIdTemp);

    }
  }
  checkLoggedinUserSystemAdminRole() {
    console.log('userObject ==>', this.userObject);
    this.isLoggedInUserSystemAdmin = this.isQualityUserLoggedIn = false;
    if (this.userObject != null && this.userObject.role != null && this.userObject.role.length > 0) {
      for (let i = 0; i < this.userObject.role.length; i++) {
        if (this.userObject.role[i].shortRoleName === 'SA') {
          this.isLoggedInUserSystemAdmin = true;
        }
        if (this.userObject.role[i].shortRoleName === 'QG') {
          this.isQualityUserLoggedIn = true;
        }
      } //End of For
    }// End of If
  }
  getKeyValuePair(array: any, keyProperty: string, valueProperty) {
    let keyValueList: KeyValue[] = [];
    array.forEach(element => {
      let kv = new KeyValue();
      kv.key = element[keyProperty];
      kv.value = element[valueProperty];
      keyValueList.push(kv);
    });
    return keyValueList;
  }
  getEngagementDetailsById(engId: number) {
    this.loadingService.startLoading();
    return this.engagementService.GetEditEngagementDetailsById(engId)
      .subscribe({
        next: result => {
          this.loadingService.stopLoading();
          this.engagement = result;
          this.getSecondarySolutionCodeById(this.engagement.parentSolutionCodeId);
          this.getDefaultClientBillingContactDetails(this.engagement.clientId);
          if (this.editMode)
            this.pushClientAndEngagementDropdown();
          if (this.engagement.status == "Active") {
            if (this.isPrepopulateFromDetails) {
              if (this.clientkeyValueList.length > 0 && this.clientkeyValueList.filter(cl => cl.key == this.engagement.clientId.toString()).length > 0) {
                this.clientId = this.engagement.clientId;
                this.BindEngagementPrefillData(this.clientId)
              }
              this.isPrepopulateFromDetails = false;
            }
            else
              this.engagementId = this.engagement.engagementId;

            this.checkPrimarySolutionCodeIsAudit(this.engagement.parentSolutionCodeId);
            this.onTemplateChange();// prefil the tempalte data
            if (!this.editMode) {
              this.workspaceId = this.engagement.workspaceId
            }
          }
          this.titleService.setTitle(`Engage | ${result.clientName} - ${this.engagementName}`)
        }, error: err => {
          console.error("getEngagementDetailsById ", err);
          this.loadingService.stopLoading();
        }
      })
  }
  onClientsChange() {
    this.isclientSelected = true;
    this.BindEngagementData(this.clientId);
    this.engagementId = -1;

  }
  onEngagementsChange() {
    this.resetFileds();
    this.engagementName = this.engagements?.find(x => x.engagementId == this.engagementId).engagementName;
    this.getEngagementDetailsById(this.engagementId);// get engagement details and load templae mapping data
    this.getChangeOrderHistory();
    this.getEngagementTeamMembers(this.engagementId);
    this.isEngagementSelected = true;
    this.getAssignmentsByEngId(this.engagementId, false);
  }
  BindEngagementData(clientId: number) {
    this.engagementService.getMyChangeOrderEngagements(this.userObject.loggedInUserEmail, clientId, this.isLoggedInUserSystemAdmin).subscribe(result => {
      this.engagements = result;
      this.engagementkeyValueList = this.getKeyValuePair(result, 'engagementId', 'engagementName');
      if (this.editMode && this.bindEditData) {
        this.pushEngagementDropdown();
        if (this.engagementkeyValueList.length > 0 && this.engagementkeyValueList.filter(eng => eng.key == this.editChangeOrderModel.engagementId.toString()).length > 0) {
          this.engagementName = this.editChangeOrderModel.engagementName;
          this.engagementId = this.editChangeOrderModel.engagementId;
        }
        else {
          this.engagementId = -1;
          this.selectedChangeOrderTemplate = "-1"
        }

        this.bindEditData = false;
      }
    });

  }

  BindEngagementPrefillData(clientId: number) {
    this.engagementService.getMyChangeOrderEngagements(this.userObject.loggedInUserEmail, clientId, this.isLoggedInUserSystemAdmin).subscribe(result => {
      this.engagements = result;
      this.engagementkeyValueList = this.getKeyValuePair(result, 'engagementId', 'engagementName');
      if (this.engagementkeyValueList.length > 0 && this.engagementkeyValueList.filter(eng => eng.key == this.engagement.engagementId.toString()).length > 0) {
        this.engagementName = this.engagement.engagementName;
        this.engagementId = this.engagement.engagementId;
        this.getEngagementTeamMembers(this.engagementId);
        this.getAssignmentsByEngId(this.engagementId, false);
        this.getChangeOrderHistory();
      }
      else
        this.engagementId = -1;


    });
  }
  getTeamMemberRoleList() {
    let applicationName = 'TeamMemberRole';
    this.applicationMasterService.GetAllTeamMemberRoles(applicationName).subscribe(
      result => {
        //this.applicationmasterList = result;
        result.forEach(element => {
          const teamMemberRoleCode = new AppCodes();
          teamMemberRoleCode.code = element.code;
          teamMemberRoleCode.codeValue = element.applicationMasterId;
          this.teamMemberRoleCodes.push(teamMemberRoleCode);
          this.applicationmasterList.push(element);
          if (element.code !== 'EP' && element.code !== 'C' && element.code !== 'A'
            && element.code !== 'CMSEP' && element.code !== 'PR') {
            this.applicationmasterListIE.push(element);
            this.teamMemberRoleFromAppMstList.push(element);
          }
          if (element.code == 'EP')
            this.eppmdRoleIdAppMaster = +element.applicationMasterId
        });
      }
    );
  }
  getDayShapeLink(url: string): string {
  if (!url) return '';

  return url.startsWith('http://') || url.startsWith('https://')
    ? url
    : 'https://' + url;
  }

  PerformDialogAction() {
    this.modalDialogRef = this.dataService.getModalDetails$.subscribe(
      dialogData => {
        if (dialogData && this.isChangeOrderScreen) {
          const modal = JSON.parse(dialogData);
          const dialogTitle = modal.dialogTitle;
          const buttonName = modal.dialogButtonName;
          if (buttonName.length > 0 &&
              (dialogTitle === EngagementDialogTitles.ChangeOrderAssignmentStartOver)) {
            this.dialogTitle = dialogTitle;
            this.dialogButtonName = buttonName;
            this.processDialogAction(this.dialogTitle, this.dialogButtonName);
          }
          console.log('Display Start Over Dialog message in change order screen ', dialogTitle);
        }
      });
  }

  processDialogAction(title: string, btnName: string) {
    switch (title) {
      case EngagementDialogTitles.ChangeOrderAssignmentStartOver:
        if (btnName === 'ok') {
          // Reset the UI and show opportunity popup
          this.handleStartOver();
        }
        // If cancel, just close - no action needed
        break;
      default:
        break;
    }
  }

  handleStartOver() {
    // Reset assignment state
    this.arrEngagementAssignment = [];
    this.resetDefaultAssignment();
     this.engAssignmentData = [];
     this.isVisibledefaultAssignmentDiv = false;
     this.isRemoveAssignmentConfirmed = true;
    // Get the assignment ID to pre-select
    const assignmentIdToSelect = this.assignmentToRemove ? this.assignmentToRemove.assignmentCodeId : this.selectedAssignmentCodeId;

    // Reset and reload assignments
    // this.selectedAssignmentCodeId = assignmentIdToSelect;
    // Mark the selected assignment as checked
    setTimeout(() => {
      if (this.primaryChangeOrderAssignments != null) {
        this.primaryChangeOrderAssignments.forEach(element => {
          if (element.assignmentCodeId === this.selectedAssignmentCodeId) {
            element.checked = true;
            this.onChangeOrderAssinmentChange(this.primaryChangeOrderAssignments.filter(x => x.checked === true && x.assignmentCodeId === this.selectedAssignmentCodeId)[0]);
          }
        });
      }

      // Clear the assignment to remove
      this.assignmentToRemove = null;
      this.isAllValidatedPassedOfAddassignment = false;
      // Open the opportunity popup
      this.onChangeOrderAssinmentChangePopup();
    }, 100);
  }

  setDialogContent(type: string, title: string) {
    this.isChangeOrderScreen = true;
    let description: string;
    let button = 2;
    let bigTitle = false;

    switch (title) {
      case EngagementDialogTitles.ChangeOrderAssignmentStartOver:
        description = 'Starting over will erase all current entries and return you to the assignment selection screen. Do you want to continue?';
        this.DisplayDialog(type, title, description, button, bigTitle);
        break;
      default:
        break;
    }
  }

  DisplayDialog(type: string, title: string, description: string, button: number, bigTitle: boolean) {
    const modalObj = {
      dialogType: type,
      dialogTitle: title,
      dialogDescription: description,
      dialogRedirectUrl: '',
      dialogButton: button,
      modalDisplay: true,
      dialogInput: '',
      dialogBigTitle: bigTitle
    };
    const modalJSON = JSON.stringify(modalObj);
    this.dataService.displayDialogNotification(modalJSON);
  }

  showStartOverDialog() {
    this.setDialogContent('information', EngagementDialogTitles.ChangeOrderAssignmentStartOver);
  }

  removeAssignment(item: any) {
    if (item != undefined) {
      // Store the assignment to be removed and show confirmation dialog
      this.assignmentToRemove = item;
      this.showStartOverDialog();
    }
  }

  objectInitialization() {
      const sc = new SecondarySolutionCode();
      sc.secondarySolutionCodeId = 0;
      sc.parentSolutionCodeId = 0;
      sc.childSolutionCodeId = 0;
      sc.solutionCode = '';
      sc.solutionCodeDescription = '';
      sc.solutionCodeLongName = '';
      sc.status = 'A';
      sc.isAudit = false;
      sc.createdBy = null;
      sc.createdDate = new Date();
      sc.lastModifiedBy = null;
      sc.lastModifiedDate = null;

      this.arrSecondarySolutionCode.push(sc);
      const defaultSelectedsolutionCode = this.secondarySolutionCodeList.find(element =>
        element.childSolutionCodeId == this.engagementList.parentSolutionCodeId);
      const defaultSelectedengagementType = new KeyValue();
      defaultSelectedengagementType.key = '';
      defaultSelectedengagementType.value = '';

      const defaultSelectedClientBillingTitle = new ContactTypes();
      defaultSelectedClientBillingTitle.id = 0;
      defaultSelectedClientBillingTitle.typeValue = '';

      this.defaultEngAssignment = {
        solutionCodeListData: this.arrSecondarySolutionCode,
        iscontingentData: this.contingentkeyValueList,
        engagementTypeData: this.engtypekeyValueList,
        selectedsolutionCode: defaultSelectedsolutionCode,
        selectedengagementType: defaultSelectedengagementType,
        assignmentCodeId: 0,
        engagementId: 0,
        solutionCodeId: 0,
        assignmentName: '',
        realization: null,
        netFees: null,
        createdBy: '',
        createdDate: new Date(),
        lastModifiedBy: '',
        lastModifiedDate: new Date(),
        assignmentAdministrator: '',
        adminEmailId: '',
        adminContactNo: '',
        cmsEPPMDName: '',
        cmsEPPMDEmailId: '',
        engagementTypeId: '0',
        isContingent: null,
        isPrimaryAssignment: false,
        netFeesInCurrencyFormat: '',
        collaborationSiteId: 0,
        engagementStartDate: null,
        engagementEndDate: null,
        officeLocationCodeId: 0,
        estimatedGrossMargin: 0,
        clientBillingContactName: '',
        clientBillingContactTitleId: 0,
        clientBillingContactEmail: '',
        collaborationSiteName: '',
        officeLocationCodeName: '',
        estimatedGrossMarginInCurrencyFormat: '',
        clientBillingContactTitle: '',
        opportunityId:this.defaultEngAssignment.opportunityId,
        opportunityName:this.defaultEngAssignment.opportunityName,
        opportunityServiceId:this.defaultEngAssignment.opportunityServiceId,
        assignmentCode: null,
        clientCode: '000',
        assignmentCodeStatus: '',
        isContinuanceCarryFrwdAssignment: false,
        solutionCodeOnSigature: false,
        priorYearAssignmentName: '',
        isGrossMarginRequire: false,
        eqcrName: '',
        eqcrEmailId: '',
        isEditEQCR: false,
        newEQCRName: '',
        newEQCREmailId: '',
        isvalidEQCR: true,
        isValidEQCRBusinessRule: true,
        isEQCRExists: false,
        solutionCode: '',
        solutionCodeDescription: '',
        isEngagementStartDateRequired: false,
        isEngagementEndDateRequired: false,
        status: null,
        dayShapeLink:'',
        isChangeOrderAssignment: false
      };

      this.newEngAssignment = {
        solutionCodeListData: this.secondarySolutionCodeList,
        assignmentCodeId: 0,
        engagementId: 0,
        solutionCodeId: this.secondarySolutionCodeList[0].parentSolutionCodeId,
        assignmentName: '',
        assignmentAdministrator: '',
        realization: null,
        netFees: null,
        createdBy: '',
        createdDate: '',
        lastModifiedBy: '',
        lastModifiedDate: ''
      };
      this.defaultEngAssignment.solutionCodeListData = this.secondarySolutionCodeList;
      this.defaultEngAssignment.solutionCodeId = this.secondarySolutionCodeList[0].parentSolutionCodeId;
      this.isDisableSolutionCode = true;
      console.log("this.defaultEngAssignment", this.defaultEngAssignment);
      this.engAssignmentData = [];
      this.engAssignmentData.push(this.defaultEngAssignment);
      this.assignmentMandatoryFieldsInitialization();
      this.controlInitialization();
    }

  getKeyTeamMemberRoleList() {
    let applicationName = 'KeyTeamMemberRole';
    this.applicationMasterService.GetAllTeamMemberRoles(applicationName).subscribe(
      result => {
        result.forEach(element => {
          const keyTeamMemberRoleCode = new AppCodes();
          keyTeamMemberRoleCode.code = element.code;
          keyTeamMemberRoleCode.codeValue = element.applicationMasterId;
          this.keyTeamMemberRoleCodes.push(keyTeamMemberRoleCode);
          //this.applicationmasterListIE.push(element);
          this.keyteamMemberRoleFromAppMstList.push(element);
        });
        this.keyteamMemberRoleFromAppMstList = this.keyteamMemberRoleFromAppMstList.sort((a, b) => Number(a.applicationMasterId) - Number(b.applicationMasterId));
      }
    );
  }
  getGoverningAgreementOption() {
    let applicationName = 'GoverningAgreementOption';
    this.applicationMasterService.GetApplicationMasterDataByName(applicationName).subscribe({
      next: result => {
        this.governingAgreementOptionAppMstList = result;
      }, error: err => {
        console.error("failed to load change order GoverningAgreementOption", err)
      }
    }
    );
  }
  getTeamMemberPermissions() {
    this.applicationMasterService.GetTeamMemberPermissions().subscribe(
      result => {
        this.teamMemberPermissions = result;
        console.log('this.teamMemberPermissions ==>', this.teamMemberPermissions);
        this.teamMemberPermissions.forEach(permission => {
          if (permission.typeValue === 'Site member') {
            this.defaultPermissionId = permission.id
          }
        })
      }
    );
  }

  setAssignmentSection() {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
      });
      this.arrEngagementAssignment = [];
      this.peoplepickerIndex = this.engAssignmentData.length;
      for (let i = 0; i < this.engAssignmentData.length; i++) {
        this.defaultEngAssignment.solutionCodeId = this.engAssignmentData[i].solutionCodeId;
        this.defaultEngAssignment.assignmentName = this.engAssignmentData[i].assignmentName;
        this.defaultEngAssignment.isContingent = Boolean(this.engAssignmentData[i].isContingent);
        this.defaultEngAssignment.cmsEPPMDName = this.engAssignmentData[i].cmsEPPMDName;
        this.defaultEngAssignment.cmsEPPMDEmailId = this.engAssignmentData[i].cmsEPPMDEmailId;
        this.defaultEngAssignment.assignmentAdministrator = this.engAssignmentData[i].assignmentAdministrator;
        this.defaultEngAssignment.adminEmailId = this.engAssignmentData[i].adminEmailId;
        this.defaultEngAssignment.adminContactNo = this.engAssignmentData[i].adminContactNo;

        if (this.engAssignmentData[i].solutionCodeId !== 0) {
          let selectedsolutionCode = this.secondarySolutionCodeList.find(s => s.childSolutionCodeId == this.engAssignmentData[i].solutionCodeId);
          this.defaultEngAssignment.selectedsolutionCode = selectedsolutionCode;
        }
        this.defaultEngAssignment.selectedengagementType =
          this.engtypekeyValueList.find(element => element.key == this.engAssignmentData[i].engagementTypeId.toString());
        this.defaultEngAssignment.assignmentCodeId = this.engAssignmentData[i].assignmentCodeId;
        this.defaultEngAssignment.engagementId = this.engAssignmentData[i].engagementId;
        //this.defaultEngAssignment.collaborationSiteId = this.engagementAssignmentList[i].collaborationSiteId;
        this.defaultEngAssignment.assignmentCode = this.engAssignmentData[i].assignmentCode;

        const defaultengagementType = new KeyValue();
        defaultengagementType.key = '';
        defaultengagementType.value = '';
        if (this.defaultEngAssignment.selectedengagementType == undefined) {
          this.defaultEngAssignment.selectedengagementType = defaultengagementType;
        }
        if (this.engAssignmentData[i].clientCode != null) {
          this.defaultEngAssignment.clientCode = this.engAssignmentData[i].clientCode.trim();
        }
        this.defaultEngAssignment.realization = this.engAssignmentData[i].realization;
        this.defaultEngAssignment.isPrimaryAssignment = this.engAssignmentData[i].isPrimaryAssignment;
        this.defaultEngAssignment.netFeesInCurrencyFormat = formatter.format(Number(this.engAssignmentData[i].netFees));
        this.defaultEngAssignment.netFees = this.engAssignmentData[i].netFees;
        this.defaultEngAssignment.engagementTypeId = this.engAssignmentData[i].engagementTypeId;
        this.defaultEngAssignment.engagementTypeData = this.engtypekeyValueList;
        this.defaultEngAssignment.iscontingentData = this.contingentkeyValueList;
        this.defaultEngAssignment.estimatedGrossMargin = this.engAssignmentData[i].estimatedGrossMargin;
        this.defaultEngAssignment.estimatedGrossMarginInCurrencyFormat =
          (this.engAssignmentData[i].estimatedGrossMargin == null || this.engAssignmentData[i].estimatedGrossMargin.toString().length === 0)
            ? ''
            : formatter.format(Number(this.engAssignmentData[i].estimatedGrossMargin));
        this.defaultEngAssignment.clientBillingContactName = this.engAssignmentData[i].clientBillingContactName;
        this.defaultEngAssignment.clientBillingContactEmail = this.engAssignmentData[i].clientBillingContactEmail;
        this.defaultEngAssignment.clientBillingContactTitleId = this.engAssignmentData[i].clientBillingContactTitleId;
        this.defaultEngAssignment.clientBillingContactTitle = this.GetClientTitle(this.engAssignmentData[i].clientBillingContactTitleId);
        //this.defaultEngAssignment.collaborationSiteName = this.GetCollaborationSiteName(this.engagementAssignmentList[i].collaborationSiteId);
        this.defaultEngAssignment.officeLocationCodeName = this.GetOfficeLocationCodeName(this.engAssignmentData[i].officeLocationCodeId);
        this.defaultEngAssignment.officeLocationCodeId = this.engAssignmentData[i].officeLocationCodeId;
        this.defaultEngAssignment.engagementStartDate = this.engAssignmentData[i].engagementStartDate;
        this.defaultEngAssignment.engagementEndDate = this.engAssignmentData[i].engagementEndDate;
        this.defaultEngAssignment.eqcrName = this.engAssignmentData[i].eqcrName;
        this.defaultEngAssignment.eqcrEmailId = this.engAssignmentData[i].eqcrEmailId;
        this.defaultEngAssignment.newEQCRName = '';
        this.defaultEngAssignment.newEQCREmailId = ''
        this.defaultEngAssignment.isvalidEQCR = true;
        this.defaultEngAssignment.isValidEQCRBusinessRule = true;
        this.defaultEngAssignment.isEQCRExists = false;
        this.defaultEngAssignment.opportunityServiceId = this.engAssignmentData[i].opportunityServiceId;
        this.defaultEngAssignment.opportunityName = this.engAssignmentData[i].opportunityName;
        this.defaultEngAssignment.opportunityId = this.engAssignmentData[i].opportunityId;
        this.defaultEngAssignment.dayShapeLink = this.engAssignmentData[i].dayShapeLink;
        this.defaultEngAssignment.isChangeOrderAssignment = this.engAssignmentData[i].isChangeOrderAssignment;
        this.arrEngagementAssignment.push(JSON.parse(JSON.stringify(this.defaultEngAssignment)));
        //set team member data
      }
      console.log('arrEngagementAssignment ==>', this.arrEngagementAssignment);
    }

  defaultSetting() {
    this.hideDefaultAssignmentBox();
   }

    GetOfficeLocationCodeName(officeLocationCodeId: number) {
    if (officeLocationCodeId !== null) {
      if (officeLocationCodeId > 0) {
        console.log('Client Locations ', this.ClientLocations, officeLocationCodeId);
        let location = this.ClientLocations.find(c => c.id == officeLocationCodeId);
        if (location != undefined) {
          return location.typeValue;
        }
        else {
          return '';
        }
      }
    } else {
      return '';
    }
  }

     GetClientTitle(clientBillingContactTitleId: number) {
    if (clientBillingContactTitleId !== null && this.ClientContactTypes && this.ClientContactTypes.length > 0) {
      if (clientBillingContactTitleId > 0) {
        return this.ClientContactTypes.find(c => c.id == clientBillingContactTitleId).typeValue;
      }
    } else {
      return '';
    }
  }

  addTeamMember() {
    $('#clientErrorMessage').text('');
    //set role name for team meber
    // if (this.isContinuanceEngagement && this.engagementCollabData.isIndus && this.engagementCollabData.carryForwadINDUSConsent) { //isindus current engagement collabsitetable == true && carryforwardindus == true && iscontinuous == true
    //   this.teamMemberRoleName = RoleNames.ICANDGIA.toString();
    // } else {
    //   this.teamMemberRoleName = RoleNames.GTUSINDUSALL.toString();
    // }
    // if (this.engagementCollabData.isIndus  || (this.isLoggedInUserSystemAdmin && this.engagement.memberFirmMappingId > 0)) {
    //   this.teamMemberRoleName = this.memberFirmData.indusConsentShortRoleName;
    // } else if (this.engagementCollabData.isIndus) {
    //   this.teamMemberRoleName = RoleNames.INDUSConsent.toString();
    // } else if (this.isMemberFirm || (this.isLoggedInUserSystemAdmin && this.engagement?.memberFirmMappingId > 0)) {
    //   this.teamMemberRoleName = this.memberFirmData?.teamMemberShortRoleName;
    // } else {
    //   this.teamMemberRoleName = RoleNames.StaffMember.toString();
    // }
    this.btnUpdateTeamBtnClick(true);
    this.teamMemberRoleName = RoleNames.StaffMember.toString();
    if (this.uiTeamMemberList != null) {
      if (this.uiTeamMemberList.length < this.teamMemberLimit) {
        //close client team members section
        // this.arrValidationForNewClientTeamMember = [];
        // this.newClientTeamMemberList = [];

        this.alertService.remove(this.alert);
        this.newTeamMember = {
          memberEmailId: '',
          memberConfirmEmail: '',
          memberName: '',
          teamMemberRole: '',
          memeberContactNo: '',
          approvalStatus: '',
          teamMemberPermissionId: 0,
          isKeyTeamMember: false,
          keyTeamMemberRoleId: 0,
          description: ''
        };

        this.uiTeamMemberList.push(this.newTeamMember);
        const ValidNewTeamMember = {
          memberEmailId: '',
          memberConfirmEmail: '',
          memberName: '',
          teamMemberRole: '',
          memeberContactNo: '',
          approvalStatus: '',
          teamMemberPermissionId: 0,
          ishdnValidInputName: true,
          isUserExist: false,
          isNewUserDuplicate: false,
          index: this.arrValidationForNewTeamMember.length
        };
        this.arrValidationForNewTeamMember.push(ValidNewTeamMember);
        console.log('addTeamMember func called', this.uiTeamMemberList, this.arrValidationForNewTeamMember);
      }
      else {
        this.alertServiceFun('You can add only ' + this.teamMemberLimit + ' team members.', 'danger');
      }
    }
  }
   openDefaultAssignmentBox() {
    this.isVisibledefaultAssignmentDiv = true;
  }
  setValidEQCRValue() {
    if (this.defaultEngAssignment.eqcrEmailId != '' && this.defaultEngAssignment.eqcrEmailId != null &&
      this.defaultEngAssignment.eqcrName != '' && this.defaultEngAssignment.eqcrName != null) {
      this.validateEQCR = true;
    } else {
      this.validateEQCR = false;
      this.defaultEngAssignment.eqcrEmailId = '';
      this.defaultEngAssignment.eqcrName = '';
    }
  }

  cancelAssignment(assignmentrowid: string) {
    this.adminDisplayUserName = '';
    this.adminDisplayUserEmail = '';
    this.validateCMSAA = false;
    this.cmsDisplayUserName = $('#txtPeoplePicker_EP_0').val();
    this.cmsDisplayUserEmail = $('#UserHiddenProps_EP_0 #hdnUserEmail').val();
    if (this.arrEngagementAssignment != null && this.arrEngagementAssignment.length >= 1) {

      this.defaultEngAssignment.eqcrName = this.arrEngagementAssignment[0].eqcrName ? this.arrEngagementAssignment[0].eqcrName : '';
      this.defaultEngAssignment.eqcrEmailId = this.arrEngagementAssignment[0].eqcrEmailId ? this.arrEngagementAssignment[0].eqcrEmailId : '';
      this.setValidEQCRValue();
    }
    if (assignmentrowid !== null && assignmentrowid !== '') {
      $('#row_' + assignmentrowid).show();
    }
    this.resetDefaultAssignment();
    if(!this.editMode && this.defaultEngAssignment === undefined)
     this.AddAssignment();
  }

   LoadAssignmentWithOpportunityService(oopService: OpportunityServiceModel, selectedOpportunity: OneViewClientOpportunityViewModel) {
    this.openDefaultAssignmentBox();
    this.defaultEngAssignment = new EngagementAssignment();
    const defaultSelectedengagementType = new KeyValue();
    defaultSelectedengagementType.key = '';
    defaultSelectedengagementType.value = '';
    let selectedsolutionCode = this.secondarySolutionCodeList.find(s => s.solutionCode == oopService.solutionCode);
    const clientLocation = this.ClientLocations.find(element => element.typeValue === selectedOpportunity.gtOfficeLocation);
    //this.GetPrepoluatedData(this.defaultEngAssignment.solutionCodeId)
    this.defaultEngAssignment = {
      solutionCodeListData: this.secondarySolutionCodeList.filter(solutionCode => solutionCode.status == 'A'),
      solutionCode: oopService.solutionCode,
      selectedsolutionCode: selectedsolutionCode,
      solutionCodeId: selectedsolutionCode?.childSolutionCodeId,
      solutionCodeDescription: selectedsolutionCode?.solutionCodeDescription,
      iscontingentData: this.contingentkeyValueList,
      opportunityId:selectedOpportunity.opportunityId,
      opportunityName:selectedOpportunity.opportunityName,
      engagementTypeData: this.engtypekeyValueList,
      selectedengagementType: defaultSelectedengagementType,
      assignmentCodeId: 0,
      engagementId: 0,
      assignmentName: '',
      realization: null,
      netFees: oopService.priceAmt,
      createdBy: '',
      createdDate: new Date(),
      lastModifiedBy: '',
      lastModifiedDate: new Date(),
      assignmentAdministrator: '',
      adminEmailId: '',
      adminContactNo: '',
      cmsEPPMDName: '',
      cmsEPPMDEmailId: '',
      engagementTypeId: '0',
      isContingent: null,
      isPrimaryAssignment: false,
      netFeesInCurrencyFormat: oopService.priceAmtFormattedValue,
      collaborationSiteId: 0,
      engagementStartDate: (selectedOpportunity.expectedStartDate != undefined || selectedOpportunity.expectedStartDate != '') ? selectedOpportunity.expectedStartDate : null,
      engagementEndDate: (selectedOpportunity.estCloseDate != undefined || selectedOpportunity.estCloseDate != '') ? selectedOpportunity.estCloseDate : null,
      officeLocationCodeId: (clientLocation != undefined) ? clientLocation.id : 0,
      officeLocationCodeName: (clientLocation != undefined) ? clientLocation.typeValue : '',
      estimatedGrossMargin: null,
      clientBillingContactName: '',
      clientBillingContactTitleId: 0,
      clientBillingContactEmail: '',
      collaborationSiteName: '',
      estimatedGrossMarginInCurrencyFormat: '',
      clientBillingContactTitle: '',
      assignmentCode: null,
      clientCode: (this.engagementList.clientCode != null && this.engagementList.clientCode != undefined && this.engagementList.clientCode.length > 0) ? this.engagementList.clientCode : null,
      assignmentCodeStatus: '',
      isContinuanceCarryFrwdAssignment: false,
      solutionCodeOnSigature: false,
      priorYearAssignmentName: '',
      isGrossMarginRequire: false,
      eqcrName: '',
      eqcrEmailId: '',
      isEditEQCR: false,
      newEQCRName: '',
      newEQCREmailId: '',
      isvalidEQCR: true,
      isValidEQCRBusinessRule: true,
      isEQCRExists: false,
      isAssignmentFinanceDataEditable: 'null',
      isEngagementStartDateRequired: false,
      isEngagementEndDateRequired: false,
      opportunityServiceId: oopService.opportunityServiceId,
      status: null,
      isChangeOrderAssignment: false
    };

    if (this.defaultEngAssignment != null && this.defaultEngAssignment != undefined
      && this.defaultEngAssignment.engagementStartDate != null) {
      const [year, month, day] = this.defaultEngAssignment.engagementStartDate?.split('-');
      var formattedDate = `${month}/${day}/${year}`
      this.defaultEngAssignment.engagementStartDate = formattedDate;
    }


    if (this.defaultEngAssignment != null && this.defaultEngAssignment != undefined
      && this.defaultEngAssignment.engagementEndDate != null) {
      const [year, month, day] = this.defaultEngAssignment.engagementEndDate?.split('-');
      var formattedDate = `${month}/${day}/${year}`
      this.defaultEngAssignment.engagementEndDate = formattedDate;
    }


    if (this.engagementList.clientId > 0) {
      if (this.defaultClientBillingContact !== undefined) {
        if ((this.defaultClientBillingContact.clientBillingEmail !== undefined ||
          this.defaultClientBillingContact.clientBillingEmail !== null) ||
          (this.defaultClientBillingContact.clientBillingName !== undefined ||
            this.defaultClientBillingContact.clientBillingName !== null)) {
          this.defaultEngAssignment.clientBillingContactEmail = this.defaultClientBillingContact.clientBillingEmail;
          this.defaultEngAssignment.clientBillingContactName = this.defaultClientBillingContact.clientBillingName;
        }
        if (this.defaultClientBillingContact.clientBillingTitleId > 0) {
          this.defaultEngAssignment.clientBillingContactTitle = this.GetClientTitle(this.defaultClientBillingContact.clientBillingTitleId);


          this.defaultEngAssignment.clientBillingContactTitleId = this.defaultClientBillingContact.clientBillingTitleId;
        }
      }
    }

    setTimeout(() => {
      $('.EstimatedStartDate').val(this.defaultEngAssignment.engagementStartDate);
      $('.EstimatedEndDate').val(this.defaultEngAssignment.engagementEndDate);
      this.arrEngagementAssignment.push(JSON.parse(JSON.stringify(this.defaultEngAssignment)));
    }, 100);

    console.log('Selected defaultEngAssignment ==>', this.defaultEngAssignment);
  }

  removeTeamMember(index: number, teamMemberRole: string) {
    // if (this.editMode) {
    //   this.loadingService.startLoading();
    //   return this.engagementService.IsDiscussionOrReviewPointExistForUser(this.currentEngagementId, this.teamMemberList[index].memberEmailId).subscribe(
    //     res => {
    //       this.discussionandReviewPointsCount = res;
    //       this.loadingService.stopLoading();
    //       if (this.discussionandReviewPointsCount == 0) {
    //         this.teamMemberList.splice(index, 1);
    //         this.arrValidationForNewTeamMember.splice(index, 1);
    //         this.renameTeammember(index, teamMemberRole);
    //         this.alertService.remove(this.alert);
    //         return true;
    //       }
    //       else {
    //         this.alertServiceFun('Team Member you are deleting has open discussions or review points. You cannot delete this team member.', 'danger');
    //         return false;
    //       }
    //     },
    //     () => {
    //       this.loadingService.stopLoading();
    //       this.alertServiceFun('Something went wrong! Please contact system administrator.', 'danger');
    //     });
    // }
    // else
    {
      this.uiTeamMemberList.splice(index, 1);
      this.arrValidationForNewTeamMember.splice(index, 1);
      this.renameTeammember(index, teamMemberRole);
      this.alertService.remove(this.alert);
      return true;
    }
    // }
    // return true;
  }
  btnUpdateTeamBtnClick(idAddTeamClicked: boolean) {
    if (idAddTeamClicked == false)
      this.changeOrderTeamMemberValidation();
    if (this.IsValidInput && !this.cmsDataMatch) {
      if (this.uiTeamMemberList?.length > 0) {
        this.changeOrderTeamMemberList = [];
        for (let t = 0; t < this.uiTeamMemberList.length; t++) {
          let selectedPermissionId = 0;
          if ($('#drpTeamMemberPermissions_' + t + ' option:selected').val() != null) {
            selectedPermissionId = parseInt($('#drpTeamMemberPermissions_' + t + ' option:selected').val());
          }
          //var iskeyTeamMember = $('#chkKeyTeamMember_' + t).val();

          var teamMemberRoleValue = '';
          if (this.isAudit) {
            teamMemberRoleValue = $('#drpKeyTeamMemberRole_' + t + ' option:selected').val();
          } else {
            teamMemberRoleValue = $('#drpTeamMemberRole_' + t + ' option:selected').val();
          }

          if (teamMemberRoleValue == null || teamMemberRoleValue == undefined || teamMemberRoleValue == '') {
            this.getTeamMemberRoleIdByCode(EnumTeamMemberRoleCodes.P);
          }

          this.newAssignTeamMember = {

            memberName: $('#UserHiddenProps_' + this.teamMemberRoleName + '_' + t + ' #hdnUserName').val(),
            memberEmailId: $('#UserHiddenProps_' + this.teamMemberRoleName + '_' + t + ' #hdnUserEmail').val(),
            memeberContactNo: $('#UserHiddenProps_' + this.teamMemberRoleName + '_' + t + ' #hdnUserPhone').val(),
            //teamMemberRole: $('#drpTeamMemberRole_' + t + ' option:selected').val(),
            teamMemberRole: teamMemberRoleValue,
            teamMemberPermissionId: selectedPermissionId,
            isKeyTeamMember: this.isAudit ? this.uiTeamMemberList[t].isKeyTeamMember : false,
            keyTeamMemberRoleId: this.isAudit ? $('#drpKeyTeamMemberRole_' + t + ' option:selected').val() : '',
            description: (this.isAudit && this.getKeyTeamMemberRoleIdByCode(EnumKeyTeamMemberRoleCodes.OTH)) ? this.uiTeamMemberList[t].description : ''
          };
          this.changeOrderTeamMemberList.push(this.newAssignTeamMember);
        }
      }
    } // end check for cmsmatchdata and valid input

  }
  OnKeyRoleChange(event, id: number) {
    let memberRoleId: number;
    memberRoleId = Number(event.target.value);
    if (this.uiTeamMemberList[id].isKeyTeamMember == true &&
      memberRoleId == this.getKeyTeamMemberRoleIdByCode(EnumKeyTeamMemberRoleCodes.OTH)) {
      $('#keyTeamMemberDescription_' + id).css('display', 'block');
    } else {
      this.uiTeamMemberList[id].description = '';
      $('#keyTeamMemberDescription_' + id).css('display', 'none');
    }
  }

  OnRoleChange(event, id: number) {
    let memberRoleId: number;
    memberRoleId = Number(event.target.value);
    if (memberRoleId == this.getTeamMemberRoleIdByCode(EnumTeamMemberRoleCodes.P)) {
      $('#drpTeamMemberPermissions_' + id).prop("disabled", false);
    } else if (memberRoleId == this.getTeamMemberRoleIdByCode(EnumTeamMemberRoleCodes.S)) {
      $('#drpTeamMemberPermissions_' + id).prop('selectedIndex', 1);
      $('#drpTeamMemberPermissions_' + id).attr('disabled', true);
    }
  }

  changeOrderTeamMemberValidation() {
    this.cmsDataMatch = false;
    this.IsValidInput = true;
    for (let t = 0; t < this.arrValidationForNewTeamMember.length; t++) {
      this.arrValidationForNewTeamMember[t].memberName = $('#txtPeoplePicker_' + this.teamMemberRoleName + '_' + t).val();
      this.arrValidationForNewTeamMember[t].teamMemberRole = this.isAudit ? $('#drpKeyTeamMemberRole_' + t).val() : $('#drpTeamMemberRole_' + t).val();
      this.arrValidationForNewTeamMember[t].teamMemberPermissionId = Number($('#drpTeamMemberPermissions_' + t).val());
      this.arrValidationForNewTeamMember[t].ishdnValidInputName = (/true/i).test($('#hdnValidInput_' + this.teamMemberRoleName + '_' + t).val());
      this.arrValidationForNewTeamMember[t].isNewUserDuplicate = false;
      this.arrValidationForNewTeamMember[t].isUserExist = false;
      this.arrValidationForNewTeamMember[t].memberEmailId = $('#UserHiddenProps_' + this.teamMemberRoleName + '_' + t + ' #hdnUserEmail').val();

      if (this.arrValidationForNewTeamMember[t].memberName === '' ||
        this.arrValidationForNewTeamMember[t].memberName === null ||
        this.arrValidationForNewTeamMember[t].memberName === undefined) {
        $('#errorLabelMemberName' + t).removeClass('d-none');
        $('#errorLabelMemberName' + t).addClass('d-block');
      } else {
        $('#errorLabelMemberName' + t).removeClass('d-block');
        $('#errorLabelMemberName' + t).addClass('d-none');
      }
      if (this.arrValidationForNewTeamMember[t].teamMemberRole === null ||
        this.arrValidationForNewTeamMember[t].teamMemberRole === '' ||
        this.arrValidationForNewTeamMember[t].teamMemberRole === undefined ||
        this.arrValidationForNewTeamMember[t].teamMemberRole === "null") {
        $('#errorLabelMemberRole' + t).removeClass('d-none');
        $('#errorLabelMemberRole' + t).addClass('d-block');
        this.arrValidationForNewTeamMember[t].teamMemberRole = null;
      } else {
        $('#errorLabelMemberRole' + t).removeClass('d-block');
        $('#errorLabelMemberRole' + t).addClass('d-none');
      }
      if (this.arrValidationForNewTeamMember[t].teamMemberPermissionId === null ||
        this.arrValidationForNewTeamMember[t].teamMemberPermissionId === undefined ||
        this.arrValidationForNewTeamMember[t].teamMemberPermissionId === -1) {
        $('#errorLabelMemberPermission' + t).removeClass('d-none');
        $('#errorLabelMemberPermission' + t).addClass('d-block');
        this.arrValidationForNewTeamMember[t].teamMemberPermissionId = null;
      } else {
        $('#errorLabelMemberPermission' + t).removeClass('d-block');

        $('#errorLabelMemberPermission' + t).addClass('d-none');
      }
      if (this.arrValidationForNewTeamMember[t].memberName === '' ||
        this.arrValidationForNewTeamMember[t].teamMemberRole === null ||
        this.arrValidationForNewTeamMember[t].teamMemberPermissionId === null ||
        this.arrValidationForNewTeamMember[t].ishdnValidInputName === false ||
        this.arrValidationForNewTeamMember[t].memberEmailId === '' ||
        this.arrValidationForNewTeamMember[t].memberEmailId === null ||
        this.arrValidationForNewTeamMember[t].memberEmailId === undefined) {
        this.IsValidInput = false;
      }
    }
    // for loop to check duplicate
    for (let t = 0; t < this.arrValidationForNewTeamMember.length; t++) {
      if (this.CheckDuplicateElement(this.arrValidationForNewTeamMember, 'memberEmailId', this.arrValidationForNewTeamMember[t].memberEmailId)) {
        this.arrValidationForNewTeamMember[t].isNewUserDuplicate = true;
        this.cmsDataMatch = true;
        this.arrValidationForNewTeamMember[t].isUserExist = true;
        $('#userExist' + t).removeClass('d-none');
        $('#userExist' + t).attr('style', 'display:block');

      }
      if (this.cmsDataMatch === false) {
        $('#userExist' + t).attr('style', 'display:none');
      }
    }
  }

  getTeamMemberRoleIdByCode(Code: string): number {
    return this.teamMemberRoleCodes.find(c => c.code === Code).codeValue;
  }
  refreshCMSAssignmentAdminPopup(index, textboxName: string) {
    this.removeRowSelection('tblAssAdminAD', 'searchAssAdminName', 'AssignmentAdminErrorMessage');
    index = this.peoplepickerIndex;

    this.ASAdminCtrl = textboxName + 'AS_' + this.assignAdminRoleName + '_' + this.peoplepickerIndex;
    this.currentAssignmentRowIndex = index;
    this.validateCMSAA = false;
    this.validateCMSEP = false;
    if ($('#' + this.ASAdminCtrl).hasClass('text-danger')) {
      $('#' + this.ASAdminCtrl).removeClass('text-danger');
    }
  }
  GetClientLocations() {
    this.applicationMasterService.GetClientLocations().subscribe(
      result => {
        this.ClientLocations = result;
      }
    );
  }

  InitializeMasterDataForAssignmentSecion(source: string) {
    this.strdefaultcontingentkeyValues = [
      {
        key: true,
        value: 'Yes'
      },
      {
        key: false,
        value: 'No'
      }
    ];
    this.contingentkeyValueList = this.strdefaultcontingentkeyValues;

    this._configService.GetListBySource(source).subscribe(
      result => {
        this.engtypekeyValueList = result;
        console.log('GetListBySource == >', this.engtypekeyValueList);
      }
    );
  }

  GetContactTypes() {
    let excludedType = 'Billing Contact';
    this.applicationMasterService.GetContactTypes().subscribe(
      contactTypes => {
        contactTypes.forEach(contact => {
          if (contact.typeValue != 'Billing Contact') {
            this.ClientContactTypes = contactTypes;
          }
        });
      }
    );
  }
  getKeyTeamMemberRoleIdByCode(Code: string): number {
    return this.keyTeamMemberRoleCodes.find(c => c.code === Code).codeValue;
  }
  private CheckDuplicateElement(array, property, value) {
    let foundElements = [];
    let elCount = 0;
    let isDuplicate = false;
    for (let element of array) {
      if (element[property] === value) {
        elCount = elCount + 1;
        if (elCount === 1) {
          foundElements.push(element);
        } else if (elCount > 1) {
          isDuplicate = true;
          break;
        }
      }
    }
    return isDuplicate;
  }

  selectTeamMember(index: any, member: MembersList) {
    $('#searchTeamMemberName').val(member.displayName);
    $('#tblMemberAD').on('click', 'tbody tr', function () {
      $(this).addClass('highlight').siblings().removeClass('highlight');
    });
    //this.selectedTM=member;
    this.selectedTMIndex = index;
  }
  deselectTeamMember() { // people picker cancel clicked
    $('#' + this.teamMemberCtrl).val('');
    $('#' + this.teamMemberCtrl).innerText = '';
    $('#' + this.teamMemberEmailCtrl + ' > #hdnUserEmail').val('');
    //$('#' + this.teamMemberEmailCtrl).innerText = '';
  }



  setTeamMember() {
    let index = this.selectedTMIndex;
    if (Number(index) >= 0) {
      const selectedMemberName = $('#spMemberdisplayName' + index).text();
      const selectedMemberEmail = $('#spMembermail' + index).text();
      const selectedMemberPhone = $('#spMemberbusinessPhones' + index).text();
      $("#TeamMemberErrorMessage").text('');
      var countofAddedTM = 0;
      for (var i in this.uiTeamMemberList) {
        if (this.uiTeamMemberList[i].memberEmailId == selectedMemberEmail) {
          countofAddedTM = countofAddedTM + 1;
        }
      }
      if (countofAddedTM == 0) {
        $('#TeamMemberErrorMessage').text('');
        $('#' + this.teamMemberCtrl).val(selectedMemberName);
        $('#' + this.teamMemberEmailCtrl + ' > #hdnUserEmail').val(selectedMemberEmail);
        this.uiTeamMemberList[this.currentTeamMemberIndex].memberName = selectedMemberName;
        this.uiTeamMemberList[this.currentTeamMemberIndex].memberEmailId = selectedMemberEmail;
        this.uiTeamMemberList[this.currentTeamMemberIndex].memeberContactNo = selectedMemberPhone;
        this.validateTM.forEach((value, memberIndex, array) => array[this.currentTeamMemberIndex] = true);
        console.log('Validate Team Members ', this.validateTM);
      }
      else {
        $('#TeamMemberErrorMessage').text('Selected Team Member is already added');
      }
    }
    this.membersListArrayForTeamMembers = null;
  }

  searchUsers(searchTextBox, tableId: string) {
    const searchText = $('#' + searchTextBox).val();
    // if (tableId === 'tblEPAD' || tableId === 'tblEQCR' || tableId === 'tblGTAgreementOwner') {
    //   this.getEPList(searchText);
    // }

    // if (tableId === 'tblAssAdminAD') {
    //   this.GetAssignmentAdmins(searchText);
    // }

    if (tableId === 'tblMemberAD') {
      this.GetTeamMembers(searchText);
    }

    /*
    $('#' + tableId + ' tr').each(function (index) {
      if (!index) return;
      $(this).find('td').each(function () {
        var id = $(this).text().toLowerCase().trim();
        var not_found = (id.indexOf(searchText) === -1);
        $(this).closest('tr').toggle(!not_found);
        return not_found;
      });
    });
*/
  }


  renameTeammember(index: number, teamMemberRole: string) {
    const rows = this.el.nativeElement.querySelectorAll('#clientUserListContainer');
    if (rows.length > 0) {
      const rowToRemove = rows[index];
      this.renderer.removeChild(this.el.nativeElement, rowToRemove);
      for (let i = index; i < rows.length - 1; i++) {
        const row = rows[i + 1];
        const txtPeoplePicker = row.querySelector('input[type="text"]:first-child');
        const hdnValidInput = row.querySelector('input[type="hidden"][id^="hdnValidInput_' + teamMemberRole + '_"]');
        const hint = row.querySelector('span[id^="hint_' + teamMemberRole + '_"]');

        const loadericon = row.querySelector('em');
        const searchUserList = row.querySelector('ul');
        const UserHiddenProps = row.querySelector('div:nth-child(4)');

        if (hdnValidInput) {
          const newId = 'hdnValidInput_' + teamMemberRole + '_' + i;
          hdnValidInput.setAttribute('id', newId);
        }
        txtPeoplePicker.id = 'txtPeoplePicker_' + teamMemberRole + '_' + i;
        loadericon.id = 'loadericon_' + teamMemberRole + '_' + i;
        searchUserList.id = 'searchUserList_' + teamMemberRole + '_' + i;
        hint.id = 'hint_' + teamMemberRole + '_' + i;

        if (UserHiddenProps) {
          const divId = UserHiddenProps.getAttribute('id');
          if (divId) {
            const newDivId = divId.replace(/_\d+$/, '_' + i);
            UserHiddenProps.setAttribute('id', newDivId);
          }
        }
        const errorDivs = row.querySelectorAll('div.error-color');
        for (let j = 0; j < errorDivs.length; j++) {
          const errorDiv = errorDivs[j];
          const errorDivId = errorDiv.getAttribute('id');
          if (errorDivId) {
            const newErrorDivId = errorDivId.replace(/_\d+$/, '_' + i);
            errorDiv.setAttribute('id', newErrorDivId);
          }
        }

      }
    }

  }

  GetTeamMembers(searchTerm: string) { // function for people picker popup
    this.loadingService.startLoading();
    let searchModel = new SearchGroupUserViewModel();
    searchModel.user = new MembersList();
    searchModel.user.displayName = searchTerm;
    // if (this.memberFirmData?.memberFirmMappingId > 0 && this.isLoggedInUserSystemAdmin) {
    //   searchModel.isMemberFirm = true;
    //   searchModel.memberFirmDomain = [];
    //   searchModel.memberFirmDomain.push(this.memberFirmData?.memberDomain)
    // }
    this.adUsersService.GetUserInformationByDisplayName(searchModel)
      .subscribe(
        userList => {
          this.loadingService.stopLoading();
          this.membersListArrayForTeamMembers = userList;
        },
        (error) => {
          console.log('Error getting result ', error);
          this.membersListArrayForTeamMembers = null;
          this.loadingService.stopLoading();
          this.alertServiceFun('Something went wrong! Please contact system administrator.', 'danger');
        });
  }

  refreshTeamMemberPopup(index, textboxName: string) { // funtion to refresh team member for people picker popup
    this.removeRowSelection('tblMemberAD', 'searchTeamMemberName', 'TeamMemberErrorMessage');
    // if (this.EditMode) {
    //   this.loadingScreenService.startLoading();
    //   return this._engService.IsDiscussionOrReviewPointExistForUser(this.currentEngagementId, this.teamMemberList[index].memberEmailId).subscribe(
    //     res => {
    //       this.discussionandReviewPointsCount = res;
    //       this.loadingScreenService.stopLoading();
    //       if (this.discussionandReviewPointsCount == 0) {
    //         this.teamMemberCtrl = textboxName + this.teamMemberRoleName + '_' + index;
    //         this.teamMemberEmailCtrl = 'UserHiddenProps_' + this.teamMemberRoleName + '_' + index;
    //         this.currentTeamMemberIndex = index;
    //         this.selectedTMIndex = null;
    //         this.validateTM.forEach((value, memberIndex, array) => array[index] = false);
    //         console.log('Validate Team Members ', this.validateTM);
    //         return true;
    //       }
    //       else {
    //         $('#modal-TeamMember').modal('hide');
    //         return false;
    //       }
    //     }, () => {
    //       this.loadingScreenService.stopLoading();
    //       this.alertServiceFun('Something went wrong! Please contact system administrator.', 'danger');
    //     });
    // }
    // else {
    this.teamMemberCtrl = textboxName + this.teamMemberRoleName + '_' + index;
    this.teamMemberEmailCtrl = 'UserHiddenProps_' + this.teamMemberRoleName + '_' + index;
    this.currentTeamMemberIndex = index;

    this.selectedTMIndex = null;
    this.validateTM.forEach((value, memberIndex, array) => array[index] = false);
    console.log('Validate Team Members ', this.validateTM);
    // }
  }
  removeRowSelection(tableId, textboxId, errorMessageId) {
    $('#' + textboxId).val('');
    $('#' + errorMessageId).text('');
    const searchText = $('#' + textboxId).val().toLowerCase().trim();
    this.searchResult(tableId, searchText);
    $('#' + tableId + ' tr').each(function () {
      if ($(this).hasClass('highlight')) {
        $(this).removeClass('highlight');
      }
    });
  }

  searchResult(tableId, searchText) {
    $('#' + tableId + ' tr').each(function (index) {
      if (!index) return;
      $(this).find('td').each(function () {
        var id = $(this).text().toLowerCase().trim();
        var not_found = (id.indexOf(searchText) === -1);
        $(this).closest('tr').toggle(!not_found);
        return not_found;
      });
    });
  }



  alertServiceFun(message, type) {
    this.alertService.remove(this.alert);
    this.alertService.add(message, type, null);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }


  // To check primary solutioncode is audit or not
  checkPrimarySolutionCodeIsAudit(primarySolutioncodeId: number) {
    if (primarySolutioncodeId > 0)
      this.engagementService.GetSolutionCodeMasterById(primarySolutioncodeId).subscribe(result => {
        this.isAudit = result.isAudit;
      });
  }

  getChangeOrderHistory() {
    this.changeOrderService.getChangeOrderHistory(this.engagementId).subscribe({
      next: result => {
        this.changeOrderHistoryList = result;
      }, error: err => {
        console.error("failed to load change order history", err)
      }
    })

  }
  getTemplateMappingData() {
    /*this.clmService.getCLMDetails(this.engagementId).subscribe({
      next: result => {
        let clmdetails: CLMDetails = result;
        let gaCategory = this.governingAgreementOptionAppMstList.find(x => x.code == clmdetails?.gaCategory);
        let gaCategoryName = ""
        if (gaCategory == undefined) {
          gaCategoryName = "None of the above."
        } else {
          gaCategoryName = gaCategory.value;
        }
        const getTemplateMappingData = this.configService.getSolutionCodeTemplateMappingData(this.documentCategory, this.engagement.parentSolutionCodeId, true);
        const getCLMTemplateMaintenanceData = this.templateMaintenanceService.getTemplateMaintenanceDataByCLMType(clmdetails.gaCategory ?? "noMSAEL"); // if CLM GACategory null then noMSAEL
        forkJoin([getTemplateMappingData, getCLMTemplateMaintenanceData]).subscribe({
          next: result => {
            let templateData = result[0];

            let templateDataCLM = result[1];
            if (templateData.length > 0) {
              this.TemplateList = templateData;
             // this.isChangeorderTemplateSelected = true;
            } else {
              this.TemplateList = [];
              this.SelectedTemplateList = [];
            }
            if (templateDataCLM.length > 0) {
              this.SelectedTemplateList = this.TemplateList.filter(o => templateDataCLM.some(({ templatePackageId ,templateCategoryCode}) =>
                o.templatePackageId === templatePackageId && templateCategoryCode===ChangeOrderTemplateEnum.Category));
            }
          }
        })

      }, error: err => {
        console.log("failed to load clm details for templates", err);
      }
    })*/

    this.configService.getSolutionCodeTemplateMappingData(this.documentCategory, this.engagement.parentSolutionCodeId, false).subscribe
      (templateData => {
        if (templateData.length > 0) {

          this.SelectedTemplateList = templateData.filter(o => o.templateCategoryCode == ChangeOrderTemplateEnum.Category)
        } else {
          this.TemplateList = [];
          this.SelectedTemplateList = [];
        }
        if (this.editMode && this.bindEditTemplateData) {
          if (this.SelectedTemplateList.filter(tm => tm.templatePackageId == this.editChangeOrderModel.templatePackageId).length > 0) {
            this.selectedChangeOrderTemplate = this.editChangeOrderModel.templatePackageId
          }
          else
            this.selectedChangeOrderTemplate = "-1";
          this.bindEditTemplateData = false;

        }

      }, err => {
        console.log("failed to load templates", err);
      }
      );
  }

  getCLMTemplateMaintenanceData() {
    // const staticValue = 'noMSAEL'; // Define the static value
    // this.SelectedTemplateList = [];
    // this.existingGACheck = false;
    // this.templateMaintenanceService.getTemplateMaintenanceDataByCLMType(staticValue).subscribe(
    //   templateDataCLM => {
    //     console.log(templateDataCLM);
    //     if (templateDataCLM.length > 0) {
    //       this.SelectedTemplateList = this.TemplateList.filter(o => templateDataCLM.some(({ templatePackageId }) =>
    //         o.templatePackageId === templatePackageId));
    //     }
    //   }, error => {
    //     this.loadingService.stopLoading();
    //     this.alertService.add('Something went wrong! Please contact the system administrator.', 'danger', null);
    //   });
  }

  onTemplateChange() {
    this.getTemplateMappingData();
  }
  onCreateChangeOrderClicked() {
    this.EstimationDate = $('.EstimateCompletionDate').val();
    this.alertService.remove( new Alert());
    this.loadingService.stopLoading();
    this.validateData();
    if(!this.isAllValidatedPassedOfAddassignment){
      this.alertService.add('Please add and save an assignment before creating the change order.', 'warning', null);
        this.loadingService.stopLoading();
      return false;
    }
    this.btnUpdateTeamBtnClick(false);
    this.addUpdateEPPMDToTeamMemberList(); // add eppmd to user list
     if (this.IsValidInput && !this.cmsDataMatch) // for team member validation
       if (this.createChangeorderValidation) { // for change order field validation
         this.addDocument();
       }
  }
  private addDocument() {
    this.addWorkspace_SelectedData.engagementId = this.engagementId;
    this.addWorkspace_SelectedData.documentAliasName = this.newEngAssignment.assignmentName.trim();
    this.addWorkspace_SelectedData.templatePackageId = this.selectedChangeOrderTemplate;
    this.addWorkspace_SiteUniqueId = this.engagement.siteUniqueID
    let changeOrderValidationModel = new ChangeOrderValidationModel();
    changeOrderValidationModel.engagementId = this.engagementId;
    changeOrderValidationModel.changeOrderName = this.newEngAssignment.assignmentName.trim();
    this.changeOrderService.getCountOfChangeOrderNameByEngagementId(changeOrderValidationModel).subscribe(
      count => {
        if (count as unknown as number > 0) {
          this.addWorkspace_SelectedData.IsDocumentAliasNameDuplicate = true;
        } else {
          this.addWorkspace_SelectedData.IsDocumentAliasNameDuplicate = false;
          this.loadingService.startLoading();
          this.createWorkitem();
        }
      },
      err => {
        this.displaySystemAlert();
      });
  }

  private createWorkitem() {
    this.addWorkspace_PrimaryWorkspaceStatus = "Draft";
    this.workspaceService.getMaxWorkspaceId().subscribe(
      result => {
        if (result <= 0) {
          result = 1;
        }
        this.createWorkItemDetails.workspaceCode = result + 3;
        this.addWorkspace_SiteUniqueId = this.engagement.siteUniqueID;
        this.createWorkItemDetails.siteUniqueId = this.addWorkspace_SiteUniqueId + '_Secondary_ChangeOrder_';

        this.createWorkItemDetails.templatePackageId = this.addWorkspace_SelectedData.templatePackageId;
        if (this.editMode) {
          this.createWorkItemDetails.templatePackageId = this.selectedChangeOrderTemplate;
        }
        this.processWorkItemCreation();
      },
      error => {
        this.displaySystemAlert();
      });
  }
  processWorkItemCreation() {
    this.hdService.GetCreateWorkItemDocumentData(this.createWorkItemDetails).subscribe(
      workItemResult => {
        this.workItemDetails = workItemResult.hdWorkItem;
        this.workspaceData.hdWorkGroupId = this.workItemDetails.workGroupId;
        this.workspaceData.hdWorkItemId = this.workItemDetails.id;
        this.workspaceData.hdTemplatePackageId = this.workItemDetails.templatePackageId;
        this.workspaceData.hdCurrentTempVersion = this.workItemDetails.templateCurrentVersion;
        this.workspaceData.status = this.addWorkspace_PrimaryWorkspaceStatus;
        this.workspaceData.hdTemplatePackageVersionId = this.workItemDetails.templatePackageVersionId;
        if (this.editMode) {
          this.workspaceData.workspaceId = this.editChangeOrderModel.workspaceId;
        }
        this.getDocumentListtoPreview(workItemResult);
      },
      error => {
        this.displaySystemAlert();
      });
  }
  getDocumentListtoPreview(workItemResult: HDWorkItemDocumentModel) {
    if (workItemResult.hdWorkItem.id != null) {
      this.addWorkspaceDocumentList = [];
      let workspaceDocument = new WorkspaceDocumentModel();
      workItemResult.hdWorkspaceDocumentList.forEach(x => {
        workspaceDocument.hdDocumentId = x.documentId;
        workspaceDocument.hdDocumentName = x.name;
        workspaceDocument.hdMimeType = x.mimeType;
        workspaceDocument.hdAssemblySession = x.assemblySessionId;
        workspaceDocument.isActive = true;
        workspaceDocument.hdTemplatePackageVersionId = this.workspaceData.hdTemplatePackageVersionId;
        workspaceDocument.documentAliasName = x.name + '-' + this.newEngAssignment.assignmentName.trim();
        workspaceDocument.engagementState = 'ChangeOrder';
        this.addWorkspaceDocumentList.push(workspaceDocument);
      });
      if (this.editMode) {
        this.updateWorkSpaceInDB();
      } else {
        this.createWorkspaceInDB();
      }
    }
  }
  updateWorkSpaceInDB() {

    this.updateWorkspacModel.engagementId = this.changeOrderModel.engagementId
    this.updateWorkspacModel.hdWorkGroupId = this.workspaceData.hdWorkGroupId;
    this.updateWorkspacModel.hdWorkItemId = this.workspaceData.hdWorkItemId;

    this.updateWorkspacModel.hdTemplatePackageId = this.workspaceData.hdTemplatePackageId;
    this.updateWorkspacModel.hdCurrentTempVersion = this.workspaceData.hdCurrentTempVersion;
    this.updateWorkspacModel.hdTemplatePackageVersionId = this.workspaceData.hdTemplatePackageVersionId
    this.updateWorkspacModel.workspaceId = this.workspaceData.workspaceId
    this.updateWorkspacModel.hdWorkItemVersionId = '';
    this.updateWorkspacModel.clientId = this.clientId.toString();
    this.updateWorkspacModel.status = 'Edit';
    this.updateWorkSpaceData.workspace = this.updateWorkspacModel;
    this.updateWorkSpaceData.document = this.addWorkspaceDocumentList;


    this.workspaceService.addUpdateWorkspace(this.updateWorkSpaceData).subscribe(
      result => {

        if (result != null && result != undefined) {
          this.changeOrderService.updateChangeOrder(this.changeOrderModel).subscribe({
            next: (result: string) => {
              this.loadingService.stopLoading();
              if (result.toLocaleLowerCase() === 'success') {
                this.router.navigate(['Interviews/' + this.changeOrderWorkspaceId]);
              } else {
                this.alertService.add('Unexpected response from server.', 'warning', null);
              }

            },
            error: (error) => {
              this.alertService.add('Something went wrong! Please contact system administrator.', 'danger', null);

            }
          });
        }
      },
      error => {
        this.displaySystemAlert();
      });
  }

  createWorkspaceInDB() {
    this.addWorkspace_InsertWorspaceDeatils.engagementId = this.engagementId;
    this.addWorkspace_InsertWorspaceDeatils.workspaceData = this.workspaceData;
    this.addWorkspace_InsertWorspaceDeatils.workspaceDocuments = this.addWorkspaceDocumentList;
    this.addWorkspace_InsertWorspaceDeatils.isCloseOutChecklist = false;
    this.workspaceService.InsertCloseoutChecklistWorkspace(this.addWorkspace_InsertWorspaceDeatils).subscribe(
      result => {
        this.loadingService.stopLoading();
        if (result != null && result != undefined && result != '') {
          this.workspaceId = result;
          this.createChangeOrder();
        }
      },
      error => {
        this.displaySystemAlert();
      });
  }


  createChangeOrder() {
    console.log("Creating change order");
    this.EstimationDate = $('.EstimateCompletionDate').val();
    // this.validateData();
    if (this.createChangeorderValidation) {
      this.changeOrderModel.engagementId = this.engagementId;
      this.changeOrderModel.engagementAssignmentCodeId = this.selectedAssignmentCodeId;
      this.changeOrderModel.changeOrderName = this.newEngAssignment.assignmentName.trim();
      this.changeOrderModel.isFinancialUpdate = this.financialUpdate;
      this.changeOrderModel.createdBy = this.userObject.loggedInUserEmail;
      this.changeOrderModel.lastModifiedBy = this.userObject.loggedInUserEmail;
      this.changeOrderModel.workspaceId = this.workspaceId;
      this.changeOrderModel.teamMembers = this.changeOrderTeamMemberList;
      this.changeOrderModel.status = "Draft";
      if (!this.changeOrderModel.isFinancialUpdate) {
        this.changeOrderModel.estimateCompletionDate = null;
        this.changeOrderModel.fee = null;
        this.changeOrderModel.grossMargin = null;
      } else {
        this.changeOrderModel.estimateCompletionDate = this.EstimationDate;
        this.changeOrderModel.fee = this.IncrementalFees;
        this.changeOrderModel.grossMargin = this.Grossmargin;
      }
      this.loadingService.startLoading();
      // Change Order Assignment values
      if (this.engAssignmentData.length > 0 &&  this.isAllValidatedPassedOfAddassignment) {
        this.changeOrderModel.ChangeOrderAssignments = this.engAssignmentData;
      }
      this.changeOrderService.createChangeOrder(this.changeOrderModel).subscribe({
        next: (result: string) => {
        this.loadingService.startLoading();
         this.createAndUpdatePermissionsModel(this.changeOrderTeamMemberList, this.engagement.siteUniqueID)
           if (result != null && result != undefined && Number(result) > 0) {
             this.addTeammembersForChangeOrder(result);
            console.log('Change order created successfully.');

          } else {
            console.error('Unexpected response:', result);
            this.alertService.add('Unexpected response from server.', 'warning', null);
          }
          this.loadingService.stopLoading();
        },
        error: (error) => {
          console.error('Error creating change order:', error);
          this.alertService.add('Something went wrong! Please contact system administrator.', 'danger', null);
          this.loadingService.stopLoading();
        }
      });
    }

  }

  addTeammembersForChangeOrder(result:any){
          // add cmsep and AA to given collaboration validaing duplicate records of team members.
                    const tempSiteMembersList: TeamMember[] = []; //temperory Array to push into collaborationSiteMembersList
                    var newAssignmentMember: any = {};
                    const collaborationSiteViewModel = new CollaborationSiteViewModel();
                    collaborationSiteViewModel.collaborationSite = new CollaborationSite();
                    collaborationSiteViewModel.engagementAssignmentList = [];
                    collaborationSiteViewModel.teamMemberList = [];

          var cmsEPMatch = false;
          var AAMatch = false;
          let collaborationSiteObject:CollaborationSite ;
         collaborationSiteObject = this.collaborationSiteList.find(c=> c.isPrimaryCollaboration);
          // check if new team member name is matching with existing team member name.
          for (let j in this.collaborationSiteMembersList) {
            if (this.newEngAssignment.cmsEPPMDEmailId.toLowerCase().trim() === this.collaborationSiteMembersList[j].memberEmailId.toLowerCase().trim() &&
              this.collaborationSiteMembersList[j].collaborationSiteId == collaborationSiteObject.collaborationSiteId) {
              cmsEPMatch = true;
            }
            if (this.newEngAssignment.adminEmailId.toLowerCase().trim() === this.collaborationSiteMembersList[j].memberEmailId.toLowerCase().trim() &&
              this.collaborationSiteMembersList[j].collaborationSiteId == collaborationSiteObject.collaborationSiteId) {
              AAMatch = true;
            }
          }

          if (!cmsEPMatch) {
            this.newCollabTeamMember = {
              collaborationSiteId: collaborationSiteObject.collaborationSiteId,
              memberName: this.newEngAssignment.cmsEPPMDName,
              memberEmailId: this.newEngAssignment.cmsEPPMDEmailId,
              memeberContactNo: null,
              jobTitle: '',
              teamMemberRole: this.getTeamMemberRoleIdByCode('P'),
              teamMemberPermissionId: this.defaultPermissionId,
              workspaceId: this.engagement.workspaceId,
              createdby: this.userObject.userName
            };
            tempSiteMembersList.push(this.newCollabTeamMember);
          }
          if (!AAMatch) {
            newAssignmentMember = {
              collaborationSiteId: collaborationSiteObject.collaborationSiteId,
              memberName: this.newEngAssignment.assignmentAdministrator,
              memberEmailId: this.newEngAssignment.adminEmailId,
              memeberContactNo: this.newEngAssignment.adminContactNo,
              jobTitle: '',
              teamMemberRole: this.getTeamMemberRoleIdByCode('P'),
              teamMemberPermissionId: this.defaultPermissionId,
              workspaceId: this.engagement.workspaceId,
              createdby: this.userObject.userName
            };
            tempSiteMembersList.push(newAssignmentMember);
          }
          collaborationSiteViewModel.teamMemberList = tempSiteMembersList;
                    collaborationSiteViewModel.collaborationSite.collaborationSiteId = Number(collaborationSiteObject.collaborationSiteId);
                    collaborationSiteViewModel.collaborationSite.engagementId = this.engagementList.engagementId;
                    collaborationSiteViewModel.collaborationSite.clientId = this.engagementList.clientId;

                    // instead of adding to existing objectlist teamMemberList call service to add new teammember to db.
                    this.workspaceService.addCollaborationTeamMembers(collaborationSiteViewModel).subscribe(
                      addedResult => {
                        if (addedResult === 'Success') {
                          // Call API for Active directory Update Permission
                          let finalSiteMembersList: CollaborationSiteMembers[] = [];

                          this.engagementService.getEngagementCollaborationsById(this.engagementId, this.isloggedInUserAdmin)
                  .subscribe(
                    result => {
                      this.engagementCollaborationsViewModel = result;
                      this.engagementList = this.engagementCollaborationsViewModel.engagement;
                      this.collaborationSiteList = this.engagementCollaborationsViewModel.collaborationSiteList;
                      this.collaborationSiteMembersList = this.engagementCollaborationsViewModel.collaborationSiteMembersList;

                          for (let j in this.collaborationSiteMembersList) {
                                                if (this.collaborationSiteMembersList[j].collaborationSiteId == collaborationSiteViewModel.collaborationSite.collaborationSiteId) {
                                                  finalSiteMembersList.push(this.collaborationSiteMembersList[j]);
                                                }
                                              }

                                              // Get List of Groups based on member Permission
                                              let siteMembersGroups = finalSiteMembersList.reduce((r, a) => {
                                                r[a.memberPermissionId] = [...r[a.memberPermissionId] || [], a];
                                                return r;
                                              }, {});

                                              console.log("siteMembersGroups", siteMembersGroups);
                                              let onwwerList: CollaborationSiteMembers[] = [];
                                              let memberList: CollaborationSiteMembers[] = [];

                                              let siteGroupTypes = Object.keys(siteMembersGroups);

                                              siteGroupTypes.forEach(type => {
                                                if ((this.teamMemberPermissions.filter(pr => pr.id == Number(type))[0]?.typeValue) === 'Site owner') {
                                                  onwwerList = finalSiteMembersList.filter(member =>
                                                    Number(member.memberPermissionId) === Number(type));
                                                } else if ((this.teamMemberPermissions.filter(pr => pr.id == Number(type))[0]?.typeValue) === 'Site member') {
                                                  memberList = finalSiteMembersList.filter(member =>
                                                    Number(member.memberPermissionId) === Number(type));
                                                }
                                              })

                                              // Site Onwers Email List
                                              let siteOwnerEmailIds: string[] = [];
                                              onwwerList.forEach(onwer => { siteOwnerEmailIds.push(onwer.memberEmailId); })

                                              //Site Members Email List
                                              let siteMemberEmailIds: string[] = [];
                                              memberList.forEach(member => { siteMemberEmailIds.push(member.memberEmailId); })

                                              let collbSiteUsersUpdatePermissionModel: UpdatePermissionsModel = new UpdatePermissionsModel();
                                              let OwnerListEmailModel: UsersListEmailModel = new UsersListEmailModel();
                                              let MemberListEmailModel: UsersListEmailModel = new UsersListEmailModel();

                                              OwnerListEmailModel.groupType = 'Owner';
                                              OwnerListEmailModel.groupUsersEmail = [];
                                              siteOwnerEmailIds.forEach(emailid => {
                                                let adUser: ADUser = new ADUser();
                                                adUser.firstName = '';
                                                adUser.lastName = '';
                                                adUser.userEmailId = emailid;
                                                OwnerListEmailModel.groupUsersEmail.push(adUser);
                                              });

                                              MemberListEmailModel.groupType = 'Member';
                                              MemberListEmailModel.groupUsersEmail = [];
                                              siteMemberEmailIds.forEach(emailid => {
                                                let adUser: ADUser = new ADUser();
                                                adUser.firstName = '';
                                                adUser.lastName = '';
                                                adUser.userEmailId = emailid;
                                                MemberListEmailModel.groupUsersEmail.push(adUser);
                                              });

                                              collbSiteUsersUpdatePermissionModel.siteType = "CollabrationSite";
                                              const foundSite = this.collaborationSiteList.find(site => site.collaborationSiteId ===
                                                collaborationSiteViewModel.collaborationSite.collaborationSiteId);
                                              collbSiteUsersUpdatePermissionModel.siteUniqueID = collaborationSiteObject.siteUniqueID;
                                              collbSiteUsersUpdatePermissionModel.usersListEmail.push(OwnerListEmailModel);
                                              collbSiteUsersUpdatePermissionModel.usersListEmail.push(MemberListEmailModel);
                                              let updatePermissionsModelList: UpdatePermissionsModel[] = [];
                                              updatePermissionsModelList.push(collbSiteUsersUpdatePermissionModel);
                                              console.log('collbSiteUsersUpdatePermissionModel ==>', collbSiteUsersUpdatePermissionModel);
                                              //4. Call Active Directory API to update latest collaborationSite Member Ids
                                              this.CallUpdatePermissions(updatePermissionsModelList);

                       });
                      }
            });

          this.loadingService.stopLoading();
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    // Remove any non-numeric characters except for the decimal point
    input.value = input.value.replace(/[^0-9.]/g, '');
  }

  setCancelDialog() {
    this.invalidvalues = "";
    this.invalidvalues = "";
    this.RedirectOnCancel();
    this.clearValidationMessages()
  }
  RedirectOnCancel() {
    if (this.editMode) {
      let prevPath = this.dataService.previousUrl.getValue();
      if (prevPath?.includes("Review"))
        this.router.navigate(['/Review/' + this.changeOrderWorkspaceId]);
      else if (prevPath?.includes("Interviews"))
        this.router.navigate(['/Interviews/' + this.changeOrderWorkspaceId]);
      else
        this.router.navigate(['/Review/' + this.changeOrderWorkspaceId]);
    }

    else
      this.router.navigate(['MyEngagements']);
  }

  validateData() {
    this.isclientSelected = this.clientId !== undefined && this.clientId !== -1;
    this.isEngagementSelected = this.engagementId !== undefined && this.engagementId !== -1;
    this.isChangeorderTemplateSelected = this.selectedChangeOrderTemplate !== undefined && this.selectedChangeOrderTemplate !== "-1" && this.selectedChangeOrderTemplate?.trim().length > 0;



    this.createChangeorderValidation = this.isclientSelected && this.isEngagementSelected && this.isChangeorderTemplateSelected;
    if(this.changeOrderAssignments.length === 0)
      this.createChangeorderValidation = false;

    // ChangeOrderAssignment Validation

  }

  enableAllValidationFlag() {

  }

  clearValidationMessages() {
    this.isGrossMarginFilled = false;
    this.isEstimationDateFilled = false;
    this.isIncrementalFeesFilled = false;
    this.isChangeorderTemplateSelected = false;
  }
  displaySystemAlert() {
    this.alertService.remove(new Alert());
    this.loadingService.stopLoading();
    this.alertService.add('Something went wrong! Please contact system administrator.', 'danger', null);
  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    if ((this.defaultEngAssignment.opportunityId == null || this.defaultEngAssignment.opportunityId == '' || this.defaultEngAssignment.opportunityId == undefined) &&
        (this.defaultEngAssignment.opportunityServiceId == null || this.defaultEngAssignment.opportunityServiceId =='' || this.defaultEngAssignment.opportunityServiceId == undefined)) {
      //Empty & Cancel Else then assume controls selected - with cancel and Not cleared
      this.selectedAssignmentCodeId = 0;
      if(!this.editMode)
      this.getAssignmentsByEngId(this.engagementId, false);
     else
      this.changeOrderAssignments = this.primaryChangeOrderAssignments;
    }
    this.isModalOpen = false;
  }


  onChangeOrderAssinmentChange(item: ChangeOrderAssignment) {
    this.defaultEngAssignment = new EngagementAssignment();
    this.selectedAssignmentCodeId = item.assignmentCodeId;
    console.log('Selected Assignment:', item);

    //Assignment opportunity popup
    if (this.changeOrderAssignments != null) {
      this.changeOrderAssignments.forEach(element => {
        if (element.assignmentCodeId === this.selectedAssignmentCodeId){
          element.checked = true;
        }
      });
    }
    if(!this.editMode || this.isRemoveAssignmentConfirmed)
    this.onChangeOrderAssinmentChangePopup();

  }

  onChangeOrderAssinmentChangePopup() {
    this.loadingService.startLoading();
    this.opportunityList = [];
    this.isDisabled = false;
    this.selectedChangeOrderClient = this.engagement;

    this.engagementAssignmentList = this.changeOrderAssignments.filter(x => x.checked === true && x.assignmentCodeId === this.selectedAssignmentCodeId);
    this.searchClientOpportunityByRequestModel.AccountId = this.engagement.oneViewAccountId;

    const primarySolutionCode = this.changeOrderAssignments.find(x => x.checked == true)?.solutionCode || '';
    this.searchClientOpportunityByRequestModel.primarySolutionCode = primarySolutionCode;

    forkJoin({
        secondaryCodes: this.engagementService.getSecondarySolutionCodeById(this.engagement.parentSolutionCodeId),
        interchangeableCodes: this.engagementService.GetInterchangeableSolutionCodes(this.engagement.parentSolutionCodeId)
    }).pipe(

      // Process both results together
      tap((result) => {
        if (result) {
          const { secondaryCodes, interchangeableCodes } = result;
          // Process secondary solution codes
          this.secondarySolutionCode = secondaryCodes;
          this.searchClientOpportunityByRequestModel.secondarySolutionCodesList = secondaryCodes?.map(item => item.solutionCode) || [];

          // Process interchangeable solution codes
          this.interchangeableSolutionCodes = interchangeableCodes;
          this.searchClientOpportunityByRequestModel.interchangeableSolutionCodesList = interchangeableCodes?.map(item => item.solutionCode) || [];
        }
      }),
      switchMap((result) => {
          if (!result) {
          return of(null);
        }
      let fetchXMLtemplateRequest = new FetchXMLTemplateRequest();
      fetchXMLtemplateRequest.templateNames = [FetchXMLTemplateNamesSource.OpportunityServicesForSecondaryAssignment];
      return this._fetchXMLTemplateService.getFetchXmlTemplatesByTemplateName(fetchXMLtemplateRequest)

      }),
        tap((templates:any) => {
        if (!templates?.length) {
          this.loadingService.stopLoading();
            console.log('Error while getting response for continuance FetchXML  ');
            return;
        }
        this.searchClientOpportunityByRequestModel.fetchXML = templates[0].fetchXmlTemplate;
      }),
      // Get opportunities
      switchMap((opportunityResult?) => {
        if (!opportunityResult) {
          return of(null);
        }
      return this.clientService.GetOpportunityServicesForSecondaryAssignment(this.searchClientOpportunityByRequestModel);

      }),
      // Handle errors gracefully
      catchError(error => {
        console.log('Error fetching engagement data');
        this.loadingService.stopLoading();
        return of(null);
        })
    ).subscribe({
        next: (opportunityResult: any) => {
          if (opportunityResult?.response) {

          this.oneViewClientOpportunityViewModelWrapper = opportunityResult.response;
          if (this.oneViewClientOpportunityViewModelWrapper != null) {
            this.opportunityList = this.oneViewClientOpportunityViewModelWrapper.oneViewClientOpportunityViewModelList.filter(opp => opp.opportunityId != null);
          }
          this.accountId = this.searchClientOpportunityByRequestModel.AccountId;
          }
          this.openModal();
          // Stop loading after modal opens
          setTimeout(() => this.loadingService.stopLoading(), 100);
        },
        error: (error) => {
          console.log('Subscription error');
          this.loadingService.stopLoading();
        }
      });
  }

  onAssignmentSelectionConfirm(selections: AssignmentChangeOrderOpportunitySelection[]) {
      if (selections && selections.length > 0) {
        const opportunityServicesList: ServiceLineWithSolutionCode[] = [];

        selections.forEach(selection => {
          if (selection.selectedOpportunityId && selection.selectedOpportunityServiceId) {
            const serviceLineSoln = new ServiceLineWithSolutionCode();
            serviceLineSoln.opportunityServiceId = selection.selectedOpportunityServiceId;
            serviceLineSoln.solutionCode = selection.solutionCode;

            serviceLineSoln.opportunityId = selection.selectedOpportunityId;
            serviceLineSoln.opportunityName = selection.availableOpportunities.find(x => x.opportunityId === selection.selectedOpportunityId)?.opportunityName || '';
            serviceLineSoln.assignmentCodeId = String(selection.assignmentId);

            // Find the opportunity service to get more details
            const opportunity = this.opportunityList.find(opp => opp.opportunityId === selection.selectedOpportunityId);
            if (opportunity && opportunity.opportunityServiceList) {
              const service = opportunity.opportunityServiceList.find(s => s.opportunityServiceId === selection.selectedOpportunityServiceId);
              if (service) {
                this.LoadAssignmentWithOpportunityService(service, opportunity);
              }
            }
            opportunityServicesList.push(serviceLineSoln);
          }
        });
        this.initializeAssignmentDetails();

        this.isModalOpen = false;
        this.errorMessage = "";
      }
    }
  //Assignment opportunity popup - Ends

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getAssignmentsByEngId(engId: number, isEdit: boolean) {
    this.loadingService.startLoading();
    var engAssignments: EngagementAssignment[];
    this.changeOrderAssignments = [];
    this.primaryChangeOrderAssignments = [];
    this.engagementService.GetEngagementAssignmentsById(engId, isEdit)
      .subscribe(
        result => {
          engAssignments = result;
           console.log("engagements data")
          if (engAssignments != null && engAssignments != undefined) {
            engAssignments.forEach((element:any) => {
              let assignment = new ChangeOrderAssignment();
                  assignment.assignmentCodeId = element.assignmentCodeId;
                  assignment.solutionCodeId = element.solutionCodeId;
                  assignment.solutionCode = element.solutionCode;
                  assignment.solutionCodeDescription = element.solutionCodeDescription;
                  assignment.assignmentName = element.assignmentName;
                  assignment.assignmentAdministrator = element.assignmentAdministrator;
                  assignment.realization = element.realization;
                  assignment.netFees = element.netFees;
                  assignment.adminEmailId = element.adminEmailId;
                  assignment.adminContactNo = element.adminContactNo;
                   assignment.engagementStartDate = element.engagementStartDate;
                   assignment.engagementEndDate= element.engagementEndDate;
                   assignment.assignmentCode = element.assignmentCode;
                  assignment.estimatedCompletetionDate = element.estimateCompletionDate;
                  assignment.cmsEPPMDName = element.cmsEPPMDName;
                  assignment.cmsEPPMDEmailId = element.cmsEPPMDEmailId;
                  assignment.engagementTypeId = element.engagementTypeId;
                  assignment.isPrimaryAssignment = element.isPrimaryAssignment;
                  assignment.officeLocationCodeId = element.officeLocationCodeId;
                  assignment.clientBillingContactName = element.clientBillingContactName;
                  assignment.clientBillingContactTitleId = element.clientBillingContactTitleId;
                  assignment.clientBillingContactEmail = element.clientBillingContactEmail;
                  assignment.eqcrName = element.eqcrName;
                  assignment.eqcrEmailId = element.eqcrEmailId;
                  assignment.opportunityServiceId = element.opportunityServiceId;
                  assignment.opportunityId = element.opportunityId;
                  assignment.opportunityName = element.opportunityName;
                  assignment.dayShapeLink = element.dayShapeLink;
                  assignment.grossMargin = element.estimatedGrossMargin;
                  assignment.incrementalFees = element.incrementalFees ? '$' + Number(element.incrementalFees).toLocaleString('en-US') : '$0';
                  assignment.estimatedStartDate = element.estimateCompletionDate;
                  assignment.StartDateCtrlId = "EstimatedStartDate" + element.assignmentCodeId;
                  assignment.createdDate = element.createdDate?.toString();
                  assignment.createdBy = element.createdBy;
                  if (assignment.estimatedCompletetionDate != null &&
                    assignment.estimatedCompletetionDate != '0001-01-01T00:00:00') {
                    assignment.visible = true;
                    assignment.checked = true;
                  } else {
                    assignment.estimatedCompletetionDate = "";
                    assignment.grossMargin = "";
                    assignment.incrementalFees = "";
                    assignment.estimatedStartDate = "";
                  }
                  assignment.isChangeOrderAssignment = element.isChangeOrderAssignment;
              if (assignment.isChangeOrderAssignment != true){
                this.changeOrderAssignments.push(assignment);
              }
            });
          }
         this.primaryChangeOrderAssignments = this.changeOrderAssignments;
         if(this.editMode){
        if (this.changeOrderAssignments != null && this.changeOrderAssignments.length > 0) {
          console.log("data comes")
          this.changeOrderAssignments = this.changeOrderAssignments.filter(x=>x.assignmentCodeId === this.editChangeOrderModel.engagementAssignmentCodeId);
          this.isVisibledefaultAssignmentDiv = false;
          this.onChangeOrderAssinmentChange(this.changeOrderAssignments[0]);
          this.prefillAssignmentDetails();
          this.isAllValidatedPassedOfAddassignment = true;
        }
        }
         this.loadingScreenService.stopLoading();
        });


  }

  getSecondarySolutionCodeById(parentSolutionCodeId: number) {
    this.engagementService.getSecondarySolutionCodeById(parentSolutionCodeId)
      .subscribe(
        res => {
          this.secondarySolutionCodeList = res;
          if (this.secondarySolutionCodeList.length > 0) {
            this.primarySelectedSolutionCode = this.secondarySolutionCodeList.find(c => c.seq == 0);

          } else {
            this.primarySelectedSolutionCode = new SecondarySolutionCode();
            this.primarySelectedSolutionCode.parentSolutionCodeId = parentSolutionCodeId;
          }
        },
        () => {
          this.secondarySolutionCodeList = []
        });
  }

 private compareDate(date1: Date, date2: Date): number {
    // With Date object we can compare dates them using the >, <, <= or >=.
    // The ==, !=, ===, and !== operators require to use date.getTime(),
    // so we need to create a new instance of Date with 'new Date()'
    let d1 = new Date(date1); let d2 = new Date(date2);

    // Check if the dates are equal
    let same = d1.getTime() === d2.getTime();
    if (same) return 0;

    // Check if the first is greater than second
    if (d1 > d2) return 1;

    // Check if the first is less than second
    if (d1 < d2) return -1;
  }


  getTeamMemberRoles() {
    return this.engagementService.GetTeamMemberRoles().subscribe(
      res => {
        this.teamMemberRoleList = res;
      },
      () => {
        this.alertServiceFun('Something went wrong! Please contact system administrator.', 'danger');
      });

  }
  getEngagementTeamMembers(engagementId: number) {
    let admin = "yes";
    this.engagementService.getEngagementCollaborationsById(engagementId, admin).subscribe({
      next: result => {
        let primaryCollaborationSiteId = result.collaborationSiteList.filter(x => x.isPrimaryCollaboration == true)[0]?.collaborationSiteId;
        if (result.collaborationSiteMembersList != undefined && result.collaborationSiteMembersList != null && result.collaborationSiteMembersList.length > 0)
          this.engagementTeamMembersList = result.collaborationSiteMembersList.filter(f => f.collaborationSiteId == primaryCollaborationSiteId);
          this.engagementList = result.engagement;
      }, error: err => {
        console.error("failed to load team members for engagement"), err;
      }
    })
  }

  addUpdateEPPMDToTeamMemberList() { // this method add eppmd from engagment to change order if user is added then mark this as eppmd team member
    this.engagementTeamMembersList.forEach(eppmdDetails => {
      this.newAssignTeamMember = {
        memberName: eppmdDetails.memberName,
        memberEmailId: eppmdDetails.memberEmailId,
        memeberContactNo: "",
        teamMemberRole: eppmdDetails.memberRoleId,
        teamMemberPermissionId: eppmdDetails.memberPermissionId ?? "",
        isKeyTeamMember: eppmdDetails.isKeyTeamMember == true ? true : false,
        keyTeamMemberRoleId: eppmdDetails.keyMemberRoleId != undefined ? eppmdDetails.keyMemberRoleId : '',
        description: eppmdDetails.description ?? ""
      };
      this.changeOrderTeamMemberList.push(this.newAssignTeamMember);
    });
    this.changeOrderTeamMemberList = this.removeDuplicate(this.changeOrderTeamMemberList, "memberEmailId");
    this.changeOrderTeamMemberList = this.removeDuplicate(this.changeOrderTeamMemberList, "memberName");

    let eppmdRoleId = this.teamMemberRoleList.find(element => element.typeValue == "Engagement Partner").id;
    let eppmdTeamMember = this.engagementTeamMembersList.find(element => element.memberRoleId == eppmdRoleId);
    let alreadyTeamMember = this.changeOrderTeamMemberList.find(element => element.memberEmailId?.trim().toLocaleLowerCase() == eppmdTeamMember?.memberEmailId.trim().toLocaleLowerCase());
    if (alreadyTeamMember == undefined && eppmdTeamMember != null && eppmdTeamMember != undefined) { // eppmd  team member not found in change order team member
      this.newAssignTeamMember = {
        memberName: eppmdTeamMember.memberName,
        memberEmailId: eppmdTeamMember.memberEmailId,
        memeberContactNo: "",
        teamMemberRole: eppmdTeamMember.memberRoleId,
        teamMemberPermissionId: eppmdTeamMember.memberPermissionId ?? "",
        isKeyTeamMember: eppmdTeamMember.isKeyTeamMember == true ? true : false,
        keyTeamMemberRoleId: eppmdTeamMember.keyMemberRoleId != undefined ? eppmdTeamMember.keyMemberRoleId : '',
        description: eppmdTeamMember.description ?? ""
      };
      this.changeOrderTeamMemberList.push(this.newAssignTeamMember);
    }
    else { // update team mmber role to eppmd if alraeady found in change order team member
      for (let i = 0; i < this.changeOrderTeamMemberList.length; i++) {
        if (this.changeOrderTeamMemberList[i].memberEmailId?.trim().toLocaleLowerCase() == eppmdTeamMember?.memberEmailId?.trim().toLocaleLowerCase()) {
          this.changeOrderTeamMemberList[i].teamMemberRole = eppmdRoleId;
          break;
        }
      }
    }
  }


  onUpdateChangeOrderClicked() {
    this.alertService.remove(new Alert());
    this.loadingService.stopLoading();
    this.validateData();
    if(!this.isAllValidatedPassedOfAddassignment){
        this.alertService.add('Please add and save an assignment before creating the change order.', 'warning', null);
         this.loadingService.stopLoading();
        return false;
    }
    if (this.createChangeorderValidation) {
      this.assignValueChangeOrder();
      if (this.selectedChangeOrderTemplate == this.editChangeOrderModel.templatePackageId) {
        this.changeOrderService.updateChangeOrder(this.changeOrderModel).subscribe({
          next: (result: string) => {
            this.loadingService.startLoading();
            if (result.toLocaleLowerCase() === 'success') {
                this.addTeammembersForChangeOrder(result);
            } else {
              this.alertService.add('Unexpected response from server.', 'warning', null);
            }
            this.loadingService.stopLoading();
          },
          error: (error) => {
            this.alertService.add('Something went wrong! Please contact system administrator.', 'danger', null);
            this.loadingService.stopLoading();
          }
        });
      }
      else {
        this.createWorkItemDetails.isDelete = true;
        this.createWorkItemDetails.id = this.CurrentWorkspaceData.hdWorkItemId;
        this.loadingService.startLoading();
        this.createWorkitem();
      }


    }
  }



  assignValueChangeOrder() {
    this.changeOrderAssignmentValues = [];
    this.changeOrderModel.changeOrderId = this.changeOrderId;
    this.changeOrderModel.engagementAssignmentCodeId = this.selectedAssignmentCodeId;
    this.changeOrderModel.templatePackageId = this.selectedChangeOrderTemplate;
    this.changeOrderModel.engagementId = this.engagementId;
    this.changeOrderModel.changeOrderName = this.defaultEngAssignment.assignmentName.trim();
    this.changeOrderModel.isFinancialUpdate = this.financialUpdate;
    this.changeOrderModel.createdBy = this.userObject.loggedInUserEmail;
    this.changeOrderModel.lastModifiedBy = this.userObject.loggedInUserEmail;
    if (!this.editMode) {
      this.changeOrderModel.workspaceId = this.workspaceId;
    } else {
      this.changeOrderModel.workspaceId = this.changeOrderWorkspaceId;
    }
    // Added for team members
    this.changeOrderModel.teamMembers = [];
    if (this.uiTeamMemberList != null && this.uiTeamMemberList.length > 0) {
      var teamMemberWorkspaceId = "";
      if (!this.editMode) {
        teamMemberWorkspaceId = this.workspaceId;
      } else {
        teamMemberWorkspaceId = this.changeOrderWorkspaceId;
      }
      var teamMberValueswithWorkSpace = [];
      this.uiTeamMemberList.forEach(element => {
        var teamMemberWorkSpace = new TeamMember();
        teamMemberWorkSpace = element;
        teamMemberWorkSpace.workspaceId = teamMemberWorkspaceId;
        teamMberValueswithWorkSpace.push(teamMemberWorkSpace);
      });
      // this.btnUpdateTeamBtnClick(false);
      for (let t = 0; t < this.uiTeamMemberList.length; t++) {
        let selectedPermissionId = 0;
        if ($('#drpTeamMemberPermissions_' + t + ' option:selected').val() != null) {
          selectedPermissionId = parseInt($('#drpTeamMemberPermissions_' + t + ' option:selected').val());
        }
        if (this.uiTeamMemberList[t].memberName == null || this.uiTeamMemberList[t].memberName == "" || this.uiTeamMemberList[t].memberName == undefined) {
          this.uiTeamMemberList[t].memberName = $('#UserHiddenProps_' + this.teamMemberRoleName + '_' + t + ' #hdnUserName').val();
          this.uiTeamMemberList[t].memberEmailId = $('#UserHiddenProps_' + this.teamMemberRoleName + '_' + t + ' #hdnUserEmail').val(),
            this.uiTeamMemberList[t].memeberContactNo = $('#UserHiddenProps_' + this.teamMemberRoleName + '_' + t + ' #hdnUserPhone').val(),
            this.uiTeamMemberList[t].teamMemberRole = this.isAudit ? this.getTeamMemberRoleIdByCode(EnumTeamMemberRoleCodes.P) : $('#drpTeamMemberRole_' + t + ' option:selected').val(),
            this.uiTeamMemberList[t].teamMemberPermissionId = selectedPermissionId,
            this.uiTeamMemberList[t].isKeyTeamMember = this.isAudit ? this.uiTeamMemberList[t].isKeyTeamMember : false,
            this.uiTeamMemberList[t].keyTeamMemberRoleId = this.isAudit ? $('#drpKeyTeamMemberRole_' + t + ' option:selected').val() : '',
            this.uiTeamMemberList[t].description = (this.isAudit && this.getKeyTeamMemberRoleIdByCode(EnumKeyTeamMemberRoleCodes.OTH)) ? this.uiTeamMemberList[t].description : ''
        }


      }
      this.changeOrderModel.teamMembers = teamMberValueswithWorkSpace;
    }
    this.changeOrderModel.createdDate = this.editChangeOrderModel?.createdDate;
    this.changeOrderModel.status = "Update";
      if (this.engAssignmentData.length > 0) {
        this.changeOrderModel.ChangeOrderAssignments = this.engAssignmentData;
    }
    return this.changeOrderModel;
  }

  resetFileds() {
    this.uiTeamMemberList = [];
    this.selectedChangeOrderTemplate = "-1";

    // Reset assignment-related variables to show radio buttons for new engagement
    this.isVisibledefaultAssignmentDiv = false;
    this.arrEngagementAssignment = [];
    this.selectedAssignmentCodeId = 0;

    if (this.changeOrderAssignments != null) {
      this.changeOrderAssignments.forEach(element => {
        if (element.checked == true) {
          element.grossMargin = "";
          element.incrementalFees = "";
          element.checked = false;
        }
      });
    }
  }


  createAndUpdatePermissionsModel(editedTeamMembers: TeamMember[], siteUniqueID: string) {
    // Get List of Groups based on Permission Drop down(GROUP By) //
    let siteMembersGroups = editedTeamMembers.reduce((r, a) => {
      r[a.teamMemberPermissionId] = [...r[a.teamMemberPermissionId] || [], a];
      return r;
    }, {});

    console.log("siteMembersGroups", siteMembersGroups);
    let onwwerList: TeamMember[] = [];
    let memberList: TeamMember[] = [];
    let siteGroupTypes = Object.keys(siteMembersGroups);

    siteGroupTypes.forEach(type => {
      if ((this.teamMemberPermissions.filter(pr => pr.id == Number(type))[0].typeValue) === 'Site owner') {
        onwwerList = editedTeamMembers.filter(member =>
          Number(member.teamMemberPermissionId) === Number(type));
      } else if ((this.teamMemberPermissions.filter(pr => pr.id == Number(type))[0].typeValue) === 'Site member') {
        memberList = editedTeamMembers.filter(member =>
          Number(member.teamMemberPermissionId) === Number(type));
      }
    })
    // Collect site onwer email List //
    let siteOwnerEmailIds: string[] = [];
    onwwerList.forEach(onwer => { siteOwnerEmailIds.push(onwer.memberEmailId); });

    // Collect site member email List //
    let siteMemberEmailIds: string[] = [];
    memberList.forEach(member => { siteMemberEmailIds.push(member.memberEmailId); });

    let EngagementSiteUsersUpdatePermissionModel: UpdatePermissionsModel = new UpdatePermissionsModel();
    let OwnerListEmailModel: UsersListEmailModel = new UsersListEmailModel();
    let MemberListEmailModel: UsersListEmailModel = new UsersListEmailModel();
    let updatePermissionsModelList: UpdatePermissionsModel[] = []

    OwnerListEmailModel.groupType = 'Owner';
    OwnerListEmailModel.groupUsersEmail = [];
    siteOwnerEmailIds.forEach(emailid => {
      let adUser: ADUser = new ADUser();
      adUser.firstName = '';
      adUser.lastName = '';
      adUser.userEmailId = emailid;
      OwnerListEmailModel.groupUsersEmail.push(adUser);
    })

    MemberListEmailModel.groupType = 'Member';
    MemberListEmailModel.groupUsersEmail = [];
    siteMemberEmailIds.forEach(emailid => {
      let adUser: ADUser = new ADUser();
      adUser.firstName = '';
      adUser.lastName = '';
      adUser.userEmailId = emailid;
      MemberListEmailModel.groupUsersEmail.push(adUser);
    })

    EngagementSiteUsersUpdatePermissionModel.siteType = "EngagementSite";
    EngagementSiteUsersUpdatePermissionModel.siteUniqueID = siteUniqueID;
    EngagementSiteUsersUpdatePermissionModel.siteURL = this.engagement.siteURL;
    EngagementSiteUsersUpdatePermissionModel.usersListEmail.push(OwnerListEmailModel);
    EngagementSiteUsersUpdatePermissionModel.usersListEmail.push(MemberListEmailModel);
    updatePermissionsModelList.push(EngagementSiteUsersUpdatePermissionModel);
    //Add client users
    // updatePermissionsModelList.push(this.GenerateClientSiteUpdatePermissionModel());
    console.log('updatePermissionsModelList ==>', updatePermissionsModelList);
    //1. Final Call Call Active Directory API to update latest collaborationSite Member Ids
    this.UpdatePermissions(updatePermissionsModelList);
    //redirect call only for edit engagement site member modification only.
    // this.dataService.setRedirectedFromEditEngagement(true);
    this.loadingService.stopLoading();
    // this.unsavedAlertfeature_IsSaveChangesOrNextBtnClicked = true;
    // this.router.navigate(this.redirectUrl);
  }

  UpdatePermissions(updatePermissionsModeList: UpdatePermissionsModel[]) {
    let updatePermissionsModelData: UpdatePermissionsModelData = new UpdatePermissionsModelData();
    updatePermissionsModelData.updatePermissionsModel = updatePermissionsModeList;
    this.activedirectoryService.UpdatePermissions(updatePermissionsModelData).subscribe(
      result => {
        //this.resultText = result;
      },
      error => {
        this.loadingService.stopLoading();
        this.alertService.add('Something went wrong! Please contact system administrator.', 'danger', null);
      });
  }
  removeDuplicate(arr, ColName) {
    var result = arr.reduce((unique, o) => {
      if (!unique.some(obj => obj[ColName] === o[ColName])) {
        unique.push(o);
      }
      return unique;
    }, []);
    return result;
  }

  getWorkspaceDetailsById() {
    if (this.editChangeOrderModel.workspaceId != null) {
      this.loadingService.startLoading();

      this.workspaceService.getWorkspaceById(this.editChangeOrderModel.workspaceId).subscribe(result => {

        this.CurrentWorkspaceData = result;

        this.loadingService.stopLoading();

      }, error => {
        this.loadingService.stopLoading();
      });
    }
  }

  onManageTeamLinkClicked() {
    if (this.engagementId > 0) {
      let url;
      url = this.router.createUrlTree(['EngagementDetail/' + this.engagementId + '/CollaborationSpaces']);
      window.open(url, '_blank');
    }
  }
  onInputChange(value: string, item: any) {
    let num = parseInt(value.replace(/[^0-9.]/g, ''));
    if (!isNaN(num)) {
      item.incrementalFees = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: value.includes('.') ? 2 : 0, maximumFractionDigits: 2
      }).format(num);
    }
    else {
      item.incrementalFees = '';
    }
  }
  onGrossMarginChange(value: string, item: any) {
    item.grossMargin = value.replace('%', '').trim();
    this.Grossmargin = Number(value.replace('%', '').trim() ?? '0');
  }
  removePercentage(item: any) {
    item.grossMargin = item.grossMargin.replace('%', '').trim();
  }
  formatPercentage(item: any) {
    if (item.grossMargin !== '' && !item.grossMargin.includes('%')) {
      item.grossMargin += '%';
    }
  }
  pushClientAndEngagementDropdown() {
    if (!this.clientkeyValueList.some(kv => kv.key === this.engagement.clientId.toString())) {
      let kv = new KeyValue();
      kv.key = this.engagement.clientId.toString();
      kv.value = this.engagement.clientName;
      this.clientkeyValueList.push(kv);
    }
  }
  pushEngagementDropdown() {
    if (!this.engagementkeyValueList.some(kv => kv.key === this.editChangeOrderModel.engagementId.toString())) {
      let kv = new KeyValue();
      kv.key = "" + this.editChangeOrderModel.engagementId;
      kv.value = this.editChangeOrderModel.engagementName;
      this.engagementkeyValueList.push(kv);
    }
  }

  redirectToCorrectEngagementState(workspaceId: string, changeOrderStatus: string) {
    this.engagementStatusViewModel = new EngagementStatusViewModel();
    this.engagementStatusViewModel.changeOrderState = changeOrderStatus;
    this.engagementStatusViewModel.workspaceId = workspaceId;
    let prevPath = this.dataService.previousUrl.getValue();
    let isHardRefreshPageReloaded = sessionStorage.getItem('isHardRefreshPageReloaded');
    let redirectURL = this.engagementService.getRedirectPathByEngagementStatus(this.engagementStatusViewModel, "C");
    let isLoginLogoutURL = false;
    if (prevPath?.includes("Login?returnUrl=")) {
      isLoginLogoutURL = true;
    }
    if (!isHardRefreshPageReloaded) {
      this.activatedRoute.snapshot;
      if (redirectURL?.length > 0 && !prevPath?.includes(redirectURL) && (prevPath == undefined || isLoginLogoutURL)) {
        this.router.navigate([redirectURL]);
        sessionStorage.removeItem('isHardRefreshPageReloaded');
      }
      else {
        sessionStorage.setItem('isHardRefreshPageReloaded', "true");
      }
    }
  }

  convertAssignmentRequestListToCreateAssignmentRequest(list: AssignmentRequest[]) {

    // Since all items share the same client info, we take the first record to populate the client model
    const firstItem = list[0];

    const result = new CreateAssignmentRequestModel();

    // 1. Map Client Data
    result.client = {
        clientCode: firstItem.client_Code,
        oneViewAccountId: firstItem.oneViewAccountId,
        clientType: firstItem.client_Type,
        clientName: firstItem.client_Name,
        clientAdministrator: firstItem.client_Administrator,
        addressLine1: firstItem.address_Line_1,
        addressLine2: firstItem.address_Line_2,
        addressLine3: firstItem.address_Line_3,
        addressLine4: firstItem.address_Line_4,
        city: firstItem.city,
        state: firstItem.state,
        country: firstItem.country,
        postalCode: firstItem.postal_Code,
        phone: firstItem.phone,
        fax: firstItem.fax,
        clientContactName: firstItem.client_Contact_Name,
        contactTypeCode: firstItem.contact_Type_Code,
        sicCode: firstItem.siC_Code,
        sicDescription: firstItem.siC_Description,
        industryCode: firstItem.industry_Code,
        industryDescription: firstItem.industry_Description,
        international: firstItem.international,
        transnational: firstItem.transnational,
        referralSourceCode: firstItem.referral_Source_Code,
        strucEntityCode: firstItem.struc_Entity_Code,
        strucEntityDesc: firstItem.struc_Entity_Desc,
        stockExchangeCode: firstItem.stock_Exchange_Code,
        stockExchangeDescription: firstItem.stock_Exchange_Description,
        tickerSymbol: firstItem.ticker_Symbol,
        clientFiscalYear: firstItem.client_Fiscal_Year,
        clientAcceptanceFlag: firstItem.client_Acceptance_Flag,
        attestationEngFlag: firstItem.attestation_Eng_Flag,
        backGroundCheckDate: firstItem.backGround_Check_Date,
        rilRequired: firstItem.riL_Required,
        rilAddedDate: firstItem.riL_Added_Date,
        independenceRules: firstItem.independence_Rules,
        independenceType: firstItem.independence_Type,
        clientFirstName: firstItem.client_First_Name,
        clientMiddleName: firstItem.client_Middle_Name,
        clientLastName: firstItem.client_Last_Name
    };

    // 2. Map Assignments Array
    result.assignments = list.map(item => ({
        initiatedBy: item.initiated_By,
        contactCompensationFlag: item.contact_Compensation_Flag,
        assignmentName: item.assignment_Name,
        assignmentAdministrator: item.assignment_Administrator,
        engagementPartner: item.engagement_Partner,
        engagementTypeCode: item.engagement_Type_Code,
        solutionCode: String(item.solution_Code),
        ratesetRealization: String(item.rateset_Realization),
        estimatedRevenue: String(item.estimated_Revenue),
        approvalDate: item.approval_Date,
        engagementId: Number(item.engagement_Id),
        assignmentCodeId: Number(item.engagement_Solution_Assignment_Code_Id),
        engagementStartDate: item.engagement_Start_Date,
        engagementEndDate: item.engagement_End_Date,
        estimatedGrossMargin: item.estimated_Gross_Margin,
        officeLocationCode: item.office_Location_Code,
        billingContactTitleCode: item.billing_Contact_Title_Code,
        billingClientContactEmail: item.billing_Client_Contact_Email,
        billingClientContactName: item.billing_Client_Contact_Name
    }));

    return result;
  }
}
